/** @jsxImportSource @emotion/react */
import { useState, useEffect, useContext } from 'react';
import { Autocomplete, Table, TableBody, TableRow, TableCell, OutlinedInput, Link, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, FormHelperText, Stack, TextField, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, Snackbar, ToggleButton, ToggleButtonGroup, Typography, useMediaQuery, useTheme, Divider, DialogContent, FormGroup, DialogActions, List, ListItem, ListItemText, TableHead } from '@mui/material';
import { useFormik } from 'formik';
import ElevatedGrid from '../../Components/ElevatedGrid';
import { Il8nContext } from '../../Helper/i18n';
import PageLayout from '../Layout/PageLayout';
import { StyledTextField } from '../../Components/CustomTextfield';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';
import { useDispatch, useSelector } from 'react-redux';
import { addStageData, updateStepper } from '../../Helper/Redux/reducers/upDown';
import { useNavigate } from 'react-router-dom';
import UploadIcon from "../../Components/DocumentUpload/UploadIcon";
import DialogForUpload from "../../Components/DocumentUpload/DialogForUpload";
import UploadDialog from "../../Components/DocumentUpload/UploadDialog";
import UploadPdf from "../../Components/DocumentUpload/UploadPdf";
import ProofDialog from "../../Components/DocumentUpload/ProofDialog";
import { steps } from '../../Helper/AppStepperData';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getValidationSchema, incomeNetWorthMapping } from "./validationSchema";
import FullScreenLoader from '../../Components/FullScreenLoader';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Popup, { PopupTitle } from '../../Components/CustomPopup';
import Upload from '../../Components/Upload';
import TextLoader from '../../Components/TextLoader';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './styles.css'
import ConsentAgreementSection from '../../Components/ConsentAgreementSection';
import { MTFConsentDataForClient, MTFConsentDataForClientObligations, MTFConsentDataForClientRights, MTFConsentForStockBrokerObligations, MTFConsentForStockBrokerRights, MTFConsentForTerminationOfRelation, MTFConsentForTermsofTBAnswer, MTFConsentMarginTradingQuestions } from '../AddressTermsAndConditions';
var isEmailVerified;
var isMobileVerified;
var oldValue = { emailRelation: "", mobileRelation: "" };
var isDigilockerFailed = false
let isPanSignZyVerified = false
let segFlag=true
let segValues=[]
const initialConsentCheckBox = {"creditPledgeInstruction": true,
  "electronicContractNoteNstatement": true,
  "shareEmailWithRegistrarNrta": true,
  "dividendInterestinBankAc": true,
  "internetTrading": true,
  "electronicAnnualReport": true,
  "rightObligation": true,
  "receiveDisslip": false,
  "dpAccountStatement": "As per SEBI Regulations",
  "casFlag": true,
  "pastAction": false,
  "pastActionReason":"",
  "casMode": "eCAS",
  "preferredDepository": "CDSL",
  "authRunningAccount": "Quaterly"
}

const initialDdpiConsentCheckBox = {
  "transferOfSecurities": true,
  "pledgingRepledgingOfSecurities": true,
  "mutualFundTransactions": true,
  "tenderingSharesInOpenOffers": true
}

function ThirdPartyKYCVerification(props) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
  const store = useSelector(state => state.storeState.stage)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [snackBarOpen, setSnackBarOpen] = useState(false)
  const [responseStatus, setResponseStatus] = useState({})
  const [isVerificationLinkSent, setIsVerificationLinkSent] = useState(false)
  const [fatcaOptions, setFatcaOptions] = useState()
  const [pincodeOptions, setPincodeOptions] = useState([])
  const [segmentOptions, setSegmentOptions] = useState([])
  const [loader, setLoader] = useState(false)
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState({ corr: false, perm: false });
  const [id, setId] = useState();
  const [isEdit, setIsEdit] = useState(false)
  const [documentsUploadedDetails, setDocumentsUploadedDetails] = useState([])
  const [documentOf, setDocumentOf] = useState()
  const [documentOfScreen, setDocumentOfScreen] = useState()
  const [openInnerDialog, setOpenInnerDialog] = useState(false);
  const [documentTypeOption, setDocumentTypeOption] = useState();
  const [documentUploadedFor, setDocumentUploadedFor] = useState();
  const [showUploadPopup, setUploadPopup] = useState(false);
  const [image, setImage] = useState();
  const [pdf, setPdf] = useState();
  const [showPdfPopup, setPdfPopup] = useState(false);
  const [docMId, setDocMId] = useState()
  const [numberOfImages, setNumberOfImages] = useState(1)
  const [documentName, setDocumentName] = useState("");
  const [documentMappingKey, setDocumentMappingKey] = useState("");
  const [openProfilePhonePopup, setOpenProfilePhonePopup] = useState(false)
  const [otp, setOtp] = useState({ contactotp: "", emailotp: "" })
  const [options, setOptions] = useState([])
  const [consentOpen, setConsentOpen] = useState(false);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const localeText = useContext(Il8nContext)
  const [generateLink, setGenerateLink] = useState()
  const [refresh, setRefresh] = useState(false);
  const [openInfoPopup, setOpenInfoPopup] = useState(false)
  const [openAddressEditPopup, setOpenAddressEditPopup] = useState(false)
  const [mitcConsentOpen, setMitcConsentOpen] = useState(false)
  const [mtfConsentOpen, setMtfConsentOpen] = useState(false)
  const [ddpiConsentOpen, setDdpiConsentOpen] = useState(false)
  const [documentData, setDocumentData] = useState([])
  const [checkedField, setCheckedField] = useState(initialConsentCheckBox)
  const [isConsentSatisfied, setIsConsentSatisfied] = useState(false)
  const [isDdpiCheckedField, setisDdpiCheckedField] = useState(initialDdpiConsentCheckBox)
  const [isDDPIConsentSatisfied, setIsDDPIConsentSatisfied] = useState(false)
  const documentTypePerName = {
    "CPOA": "Corresponding Address",
    "PPOA": "Permanent Address",
    "POA": "Power of Attorney",
    "POI": "Proof Of Identity",
    "Sign": "Signature",
    "Photo": "Photograph",
    "KYCP": "KYC Proof",
    "DePr": "Demat Proof",
    "BaPr": "Bank Proof",
    "InPr": "Income Proof",
    "Nom": "Nominee Proof",
    "Gurd": "Guardian Proof",
    "IPV": "In-Person Verification",
    "KRA": "KYC KRA Page",
    "default": "Document Upload",
    "BalSh": "Copy of Balance sheet of past two years",
    "AuSig": "Authorised Signatory on letter head of Firm/Company",
    "ITR": "IT Return for last 2 financial years",
    "PDeed": "Partnership  deed",
    "PCapR": "Partnership capital ratio",
    "DMapL": "Demat account Mapping Letter",
    "MOA": "MOA and AOA of the company",
    "Annx": "Annexure page",
    "BoRes": "Board Resolution",
    "NetWo": "Net Worth Certificate",
    "RCert": "Registration Certificate",
    "Oth": "Others",
  }

  const documentICONS = {
    "CPOA": "/images/Address Proof.svg",
    "PPOA": "/images/Address Proof.svg",
    "POI": "/images/Photo ID Proof.svg",
    "Sign": "/images/Signature.svg",
    "Photo": "/images/Photo.svg",
    "BaPr": "/images/Bank-Proof.svg",
    "IPV": "/images/IPV (Video Recording).svg",
    "Oth": "/images/Signature.svg"
  }

  const MITCContentData=[
    {instruction:localeText?.consentAddressInstr1},
    {instruction:localeText?.consentAddressInstr2},
    {instruction:localeText?.consentAddressInstr3},
    {instruction:localeText?.consentAddressInstr4},
    {instruction:localeText?.consentAddressInstr5},
    {instruction:localeText?.consentAddressInstr6},
    {instruction:localeText?.consentAddressInstr7},
    {instruction:localeText?.consentAddressInstr8},
    {instruction:localeText?.consentAddressInstr9},
    {instruction:localeText?.consentAddressInstr10},
]

useEffect(() => {
    const ignoreConsent = ["authRunningAccount"]
    var tempinitalConsent = {...initialConsentCheckBox}
    var tempcheckfield = {...checkedField}
    ignoreConsent.map(consent =>{
        delete tempinitalConsent[consent]
        delete tempcheckfield[consent]
    })
    setIsConsentSatisfied(JSON.stringify(tempcheckfield) != JSON.stringify(tempinitalConsent))
}, [checkedField])

useEffect(() => {
    var tempinitalConsent = {...initialDdpiConsentCheckBox}
    var tempcheckfield = {...isDdpiCheckedField}
    setIsDDPIConsentSatisfied(JSON.stringify(tempcheckfield) != JSON.stringify(tempinitalConsent))
}, [isDdpiCheckedField])

  useEffect(() => {
    getSegments()
    getFATCAOptions()
    getContactVerificationDetails()
    getContactRelationOptions()
    let data = store.digilockerData || {}
    initializeForm(JSON.parse(localStorage.getItem('digilocker')))

    if (store.isDigilockerDataFound == true) {
      setResponseStatus({ "message": localeText?.DigiLockerKYCVerificationAllDocumentUpload, "type": "success" })
      setSnackBarOpen(true)
      dispatch(addStageData({ ...store, isDigilockerDataFound: false }))
    }
    getIncomeProofDocumentDetails()

  }, [])

  const getSegments = () => {
    axios.get(process.env.REACT_APP_API_URL + config.segments).then(resp => {
      if (resp.data.success) {
        setSegmentOptions(resp.data.success.segments || [])
      } else {
        throw new Error(resp.data.error)
      }
    }).catch(err => {
      console.log(err.message)
    })
  }

  const getContactVerificationDetails = () => {
    setRefresh(true)
    axios.get(process.env.REACT_APP_API_URL + config.contactVerification).then(resp => {
      if (resp.data.success) {
        dispatch(addStageData({ ...store, ...resp.data.success }))
        setRefresh(false)
        isEmailVerified = resp.data.success.emailVerified ? 'Y' : 'N'
        isMobileVerified = resp.data.success.mobileVerified ? 'Y' : 'N'
        // formik.setFieldValue("emailVerified", resp.data.success.emailVerified ? 'Y' : 'N')
        // formik.setFieldValue("mobileVerified", resp.data.success.mobileVerified ? 'Y' : "N")
        oldValue.emailRelation = resp.data.success.emailVerified && formik.values.emailRelation
        oldValue.mobileRelation = resp.data.success.mobileVerified && formik.values.mobileRelation
      }
      else {
        setRefresh(false)
        throw new Error(resp.data.error)
      }
    }).catch((err) => {
      console.log(err.message)
    })
  }

  const getContactRelationOptions = () => {
    axios.get(process.env.REACT_APP_API_URL + config.relationOptions).then(resp => {
      if (resp.data.success) {
        setOptions(resp.data.success)
      }
      else {
        throw new Error(resp.data.error)
      }
    }).catch((err) => {
      console.log(err.message)
    })
  }

  const initializeForm = () => {
    let data = store.digilockerData || {};

    formik.setValues({
      pan: data?.pan ? data.pan : "",
      accountOpeningType:data.accountOpeningType || "",
      firstName:data?.pan ? data.firstName :"",
      middleName:data?.pan ? data.middleName : "",
      lastName:data?.pan ? data.lastName : "",
      dateofBirth: data?.pan ? (data.dateofBirth && Number(data.dateofBirth)) : new Date().getTime(),
      nameAsPerPan: data.nameAsPerPan || '',
      apCode: data.apCode || "",
      isIndian: data.isIndian || "",
      isTradebullDeclare: true,
      segment: [1, 2],

      gender: data.gender || "",
      fatherOrSpouse: data.fatherOrSpouse || "",
      fathersSpouseFirstName: data.fathersSpouseFirstName || "",
      fathersSpouseMiddleName: data.fathersSpouseMiddleName || "",
      fathersSpouseLastName: data.fathersSpouseLastName || "",
      maritialStatus: data.maritialStatus || "",
      mobile: data.mobile || "",
      mobileRelation: data.mobileRelation || "",

      email: data.email || "",
      emailRelation: data.emailRelation || "",
      mothersFirstName: data?.mothersFirstName || "",
      mothersMiddlename: data?.mothersMiddlename || "",
      mothersLastName: data?.mothersLastName || "",

      addressLine1: data.addressLine1 || "",
      addressLine2: data.addressLine2 || "",
      addressLine3: data.addressLine3 || "",
      landmark: data.landmark || "",
      pincode: data.pincode || "",
      state: data.state || "",
      city: data.city || "",
      country: data.country || "",
      isPermanentAddressSameasCorrespondence: true,
      perAddressLine1: data.addressLine1 || "",
      perAddressLine2: data.addressLine2 || "",
      perAddressLine3: data.addressLine3 || "",
      perLandmark: data.landmark || "",
      perPincode: data.pincode || "",
      PerState: data.state || "",
      perCity: data.city || "",
      perCountry: data.country || "",
      // extra keys added
      // correspondenceAddress: `${data.addressLine1 || ""}${data.addressLine2 ? (data.addressLine1 ? ", " + data.addressLine2 : data.addressLine2) : ""}${data.addressLine3 ? (data.addressLine2 ? ", " + data.addressLine3 : data.addressLine3) : ""}`,
      // permanentAddress: `${data.addressLine1 || ""}${data.addressLine2 ? (data.addressLine1 ? ", " + data.addressLine2 : data.addressLine2) : ""}${data.addressLine3 ? (data.addressLine2 ? ", " + data.addressLine3 : data.addressLine3) : ""}`,

      anualIncomeRange: (data.anualIncomeRange && Number(data.anualIncomeRange)) || "",
      networth: (data.networth && Number(data.networth)) || "",
      networthDate: (data.networthDate && Number(data.networthDate)) || getLastDateOfFinancialYear(),
      occupation: (data.occupation && Number(data.occupation)) || "",
      tradingExp: data.tradingExp || "",
      politicalAffiliations: data.politicalAffiliations || "",
      natureOfBusiness: (data.natureOfBusiness && Number(data.natureOfBusiness)) || "",
      natureOfBusinessOther: data.natureOfBusinessOther || "",
      sourceOfWealth: (data.sourceOfWealth && Number(data.sourceOfWealth)) || "",
      placeOfBirth: data.placeOfBirth || "",
      countryOfBirth: data.countryOfBirth || "",
      networth: data.networth || "",
      isFatca: data.isFatca || false,
      isAgreeToConcent: data.isAgreeToConcent || false,
      isAgreeMITC:data.isAgreeMITC || false,
      isDDPIConsent:data.isDDPIConsent || false,
      isMTFDeclaration:data.isMTFDeclaration || false,
      isAadhaarSeeded:data.isAadhaarSeeded || false,
      aadhaarSeededMessage:data.aadhaarSeededMessage || "",
      isPanVerified:data.isPanVerified || false
    })
  }

  const getFATCAOptions = () => {
    axios.get(process.env.REACT_APP_API_URL + config.getFATCAOptions)
        .then(resp => {
            if (resp.data.success) {
                var optionsData = resp.data.success;
                const othersList = [{
                    "id": 5,
                    "natureOfBusinessDesc": "Others",
                    "isActive": true
                }];
                const natureOfBusinessAllList = [
                    {
                        "id": 1,
                        "natureOfBusinessDesc": "Manufacturing",
                        "isActive": true
                    },
                    {
                        "id": 2,
                        "natureOfBusinessDesc": "Services",
                        "isActive": true
                    },
                    {
                        "id": 3,
                        "natureOfBusinessDesc": "Trading",
                        "isActive": true
                    },
                    {
                        "id": 4,
                        "natureOfBusinessDesc": "Consultancy",
                        "isActive": true
                    },
                    {
                        "id": 5,
                        "natureOfBusinessDesc": "Others",
                        "isActive": true
                    }
                ]
                optionsData.occupationList?.map(occupation =>{
                    if(occupation.selectValue == "5-Private Sector"){
                        occupation["natureOfBusinessList"] = othersList
                        occupation["isOtherAllowed"] = false
                    }
                    else if(occupation.selectValue == "6-Public Sector"){
                        occupation["natureOfBusinessList"] = othersList
                        occupation["isOtherAllowed"] = false
                    }
                    else if(occupation.selectValue == "7-Govt. service"){
                        occupation["natureOfBusinessList"] = othersList
                        occupation["isOtherAllowed"] = false
                    }
                    else if(occupation.selectValue == "8-Professional"){
                        occupation["natureOfBusinessList"] = [{
                            "id": 2,
                            "natureOfBusinessDesc": "Services",
                            "isActive": true
                        }]
                    }
                    else if(occupation.selectValue == "9-Self Employed"){
                        occupation["natureOfBusinessList"] = natureOfBusinessAllList
                        occupation["isOtherAllowed"] = true
                    }
                    else if(occupation.selectValue == "10-Retired"){
                        occupation["natureOfBusinessList"] = othersList
                        occupation["isOtherAllowed"] = false
                    }
                    else if(occupation.selectValue == "11-Housewife"){
                        occupation["natureOfBusinessList"] = othersList
                        occupation["isOtherAllowed"] = false
                    }
                    else if(occupation.selectValue == "11-Housewife"){
                        occupation["natureOfBusinessList"] = othersList
                        occupation["isOtherAllowed"] = false
                    }
                    else if(occupation.selectValue == "12-Student"){
                        occupation["natureOfBusinessList"] = othersList
                        occupation["isOtherAllowed"] = false
                    }
                    else if(occupation.selectValue == "13-Business"){
                        occupation["natureOfBusinessList"] = natureOfBusinessAllList
                        occupation["isOtherAllowed"] = true
                    }
                })
                setFatcaOptions(resp.data.success)
            }
            else {
                throw new Error(resp.data.error)
            }
        }).catch((err) => {
            console.log(err.message)
        })
}

  function handleSnackBarClose() {
    setSnackBarOpen(false)
    setResponseStatus()
  }

  const handleToggleInfoPopup = () =>{
    setOpenInfoPopup(!openInfoPopup)
}

  const toggleAddressEdittingPopup = () => {
    setOpenAddressEditPopup(!openAddressEditPopup)
  }


  const handleSubmit = (values) => {
    if (isEdit) {
      if (uploadedDocuments.length == 0 || (values.isPermanentAddressSameasCorrespondence && !uploadedDocuments.find(doc => doc.documentTypeCode == 'CPOA')) ||
        (!values.isPermanentAddressSameasCorrespondence && !uploadedDocuments.find(doc => doc.documentTypeCode == 'PPOA'))) {
        // if (!values.isPermanentAddressSameasCorrespondence || !uploadedDocuments.find(upload => upload.documentOf)) {
        setResponseStatus({ "message": localeText?.DigiLockerKYCVerificationDocumentUpload, "type": "error" })
        setSnackBarOpen(true)
        return
      } else {
        submitData(values)
      }
    } else {
      submitData(values)
    }
  }

  const submitData = (values) => {
    if ( checkSegments() && !uploadedDocuments.find(upload => upload.documentTypeCode) ) {
        setResponseStatus({ "message": "Segment Document Upload Mandatory", "type": "error" })
        setSnackBarOpen(true)
        return
    }
    console.log(values, 'values')
    setLoading(true)
    let payload = {
      ...values,
      segment: values.segment.join(","),
      isDataEdited: isEdit,
      consent: checkedField
    };
    // delete payload.correspondenceAddress
    // delete payload.permanentAddress
    axios.post(process.env.REACT_APP_API_URL + config.addDigiLockerData, payload).then(resp => {
      setLoading(false)
      if (resp.data.success) {
        dispatch(updateStepper({ step: 1, nestedStep: 1 }));
        dispatch(updateStepper({ step: 2, nestedStep: 2 }));
        dispatch(addStageData({...store, isFreshUser:true}))
        navigate("/NomineeDetails")
        isDigilockerFailed = false
      } else {
        throw new Error(resp.data.error)
      }
    }).catch((err) => {
      setLoading(false)
      setResponseStatus({ "message": err.message, "type": "error" })
      setSnackBarOpen(true)
      setOpenInfoPopup(true)
      isDigilockerFailed = true
    })
  }

  const handleChangePan = (e) =>{
    if((e.target.value)?.length == 10){
      fetchPanRelatedData(e.target.value)
    }
  }

  const fetchPanRelatedData = (panNum) => {
    if(panNum == "" || Boolean(formik.errors.panNumber)){
       setSnackBarOpen(true)
       setResponseStatus({ "message": formik.errors.panNumber || "PAN is required", "type": "error" })
    }else{
        setLoading(true)
      if (panNum) {
        let payload = {
          "pan": panNum
        }
        axios.post(process.env.REACT_APP_AARAMBHAH_URL + config.getPanRelateData, payload)
          .then(resp => {
            if (resp?.data?.success) {
              var dateParts = resp.data?.success[0]?.dateOfBirth.split("/");
              const dob = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
              formik.setFieldValue("firstName", resp.data.success[0]?.firstName || "");
              formik.setFieldValue("middleName", resp.data.success[0]?.middleName || "");
              formik.setFieldValue("lastName", resp.data.success[0]?.lastName || "");
              formik.setFieldValue("dateofBirth", dob.getTime() || new Date().getTime());
              isPanSignZyVerified = true
            }
            else {
              setResponseStatus({ "message": resp.data.error, "type": "error" })
              setSnackBarOpen(true)
            }
            setLoading(false)
          })
          .catch(error => {
            setResponseStatus({ "message": error.message, "type": "error" })
            setSnackBarOpen(true)
            setLoading(false)
          })
      }
    }
}

  const formik = useFormik({
    initialValues: {
      pan: "",
      accountOpeningType:"",
      firstName:"",
      middleName:"",
      lastName:"",
      dateofBirth: new Date(),
      nameAsPerPan: '',
      apCode: "",
      isIndian: true,
      segment: [1, 2],
      isTradebullDeclare: true,

      gender: "",
      fatherOrSpouse: "",
      fathersSpouseFirstName: "",
      fathersSpouseMiddleName: "",
      fathersSpouseLastName: "",
      maritialStatus: "",
      mobile: "",
      mobileRelation: "",
      email: "",
      emailRelation: "",
      mobileVerified: "N",
      mothersFirstName: "",
      mothersMiddlename: "",
      mothersLastName: "",

      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      landmark: "",
      pincode: "",
      state: "",
      city: "",
      country: "",
      isPermanentAddressSameasCorrespondence: false,
      perAddressLine1: "",
      perAddressLine2: "",
      perAddressLine3: "",
      perLandmark: "",
      perPincode: "",
      PerState: "",
      perCity: "",
      perCountry: "",

      anualIncomeRange: "",
      networth: "",
      networthDate:"",
      occupation: "",
      tradingExp: "",
      politicalAffiliations: "",
      natureOfBusiness: "",
      natureOfBusinessOther: "",
      sourceOfWealth: "",
      placeOfBirth: "",
      countryOfBirth: "",
      isFatca: false,
      isAgreeToConcent: false,
      isAgreeMITC:false,
      isDDPIConsent:false,
      isMTFDeclaration:false,
    },
    validationSchema: getValidationSchema(isEdit),
    onSubmit: (values) => {
      handleSubmit(values)
    },
  });

  const handleSameAsCorrAddress = (e) => {
    let value = e.target.checked;
    if (value) {
      formik.setFieldValue("perAddressLine1", formik.values.addressLine1)
      formik.setFieldValue("perAddressLine2", formik.values.addressLine2)
      formik.setFieldValue("perAddressLine3", formik.values.addressLine3)
      formik.setFieldValue("perPincode", formik.values.pincode)
      formik.setFieldValue("PerState", formik.values.state)
      formik.setFieldValue("perCity", formik.values.city)
    }
  }

  const setPincodeSearchFields = (searchedItem, addressType) => {
    if (addressType == "corr") {
      formik.setFieldValue("pincode", searchedItem.pinCode)
      formik.setFieldValue("state", searchedItem.state)
      formik.setFieldValue("city", searchedItem.city)
    }
    if (addressType == "perm" || formik.values.isPermanentAddressSameasCorrespondence) {
      formik.setFieldValue("perPincode", searchedItem.pinCode)
      formik.setFieldValue("PerState", searchedItem.state)
      formik.setFieldValue("perCity", searchedItem.city)
    }
    setOpen({ ...open, [addressType]: false })
    setPincodeOptions([])
  }

  let timer;
  const handlePincodeSearch = (e) => {
    if (e.target.value.length > 2) {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        setPincodeOptions([])
        let dataObj = {
          key: e.target.value,
          type: "pinCode"
        }
        axios.post(process.env.REACT_APP_API_URL + config.search, dataObj)
          .then(resp => {
            if (resp.data.success) {
              setPincodeOptions(resp.data.success)
            }
            else {
              throw new Error(resp.data.error)
            }
          }).catch((error) => {
            setResponseStatus({ "message": error.message, "type": "error" })
            setSnackBarOpen(true)
          })
      }, 1000)
    }
  }

  const getOptionComponent = (searchedItem, addressType) => {
    return <Grid item css={{ width: "100%", padding: "20px", borderTop: "1px solid grey", cursor: "pointer" }} onClick={() => setPincodeSearchFields(searchedItem, addressType)}>
      <Typography variant='body1' css={{ fontWeight: "bold" }}>
        {localeText?.DigiLockerKYCVerificationPinCode + searchedItem.pinCode}
      </Typography>
      <Typography variant='body2'>
        {localeText?.DigiLockerKYCVerificationState + searchedItem.state}
      </Typography>
      <Typography variant='body2'>
        {localeText?.DigiLockerKYCVerificationCity + searchedItem.city}
      </Typography>
    </Grid>
  }

  const handleSameAsCorrespondenceChecked = (e, fieldName) => {
    if (formik.values.isPermanentAddressSameasCorrespondence) {
      formik.setFieldValue(fieldName, e.currentTarget.value)
    }
  }

  function toogleInnerDialog() {
    setOpenInnerDialog(!openInnerDialog);
  }

  var getDocumentTypeOptions = (documentTypeCode, documentUploadedForValue, documentOfValue, screenOf) => {
    setDocumentTypeOption(documentTypeCode)
    setOpenInnerDialog(!openInnerDialog)
    setDocumentUploadedFor(documentUploadedForValue)
    setDocumentOf(documentOfValue)
    setDocumentOfScreen(screenOf)
  }

  const onFile = (prm, docId, count, name, mappingKey) => {
    prm.then(succ => {
      toogleInnerDialog()
      if (succ.type.includes("pdf")) {
        setPdf(succ)
        setPdfPopup(true)
      } else {
        setImage([succ.data])
        setUploadPopup(true)
      }
      setDocMId(docId)
      setNumberOfImages(count)
      setDocumentName(name)
      setDocumentMappingKey(mappingKey)
    })
  }

  var uploadDocument = (documentData) => {
    setLoading(true)
    let documentArr = [...documentsUploadedDetails];
    let count = 0;
    documentData.forEach(document => {
      axios.post(`${process.env.REACT_APP_API_URL}${config.uploadDocument}`, document).then(response => {
        count++;
        setLoading(false)
        if (response.data.success) {
          var docNotUploaded = response.data.success.find(docResponse => docResponse.Status == false)

          if (docNotUploaded) {
            setResponseStatus({ "message": `${localeText?.DigiLockerKYCVerificationUnable}${docNotUploaded.uploadId}`, "type": "error" })
            setSnackBarOpen(true)
          } else {
            if (documentTypeOption.toLowerCase().includes("nom")) {
              // store.dispatch(change("nomineeDetails", "nomineeIdentification"+currentDocumentIndex, documentMappingKey))
              // store.dispatch(change("nomineeDetails", "nomineeIdentificationDetails"+currentDocumentIndex, ""))
            } else if (documentTypeOption.toLowerCase().includes("gurd")) {
              // store.dispatch(change("nomineeDetails", "guardianIdentification"+currentDocumentIndex, documentMappingKey))
              // store.dispatch(change("nomineeDetails", "guardianIdentificationDetails"+currentDocumentIndex, ""))
            }
            setResponseStatus({ "message": localeText?.DigiLockerKYCVerificationSuccessfully, "type": "success" })
            setSnackBarOpen(true)
            documentArr = [...documentArr, {
              "documentTypeCode": document.docTypeCode,
              "proofId": response.data.success[0].id,
              "documentOf": documentOf,
              "documentScreen": documentOfScreen
            }]
            count == documentData.length && setDocumentsUploadedDetails(documentArr)
          }
        }
        if (response.data.error) {
          setResponseStatus({ "message": response.data.error, "type": "error" })
          setSnackBarOpen(true)
        }
      }).catch(exception => {
        setLoading(false)
        setResponseStatus({ "message": exception.message, "type": "error" })
        setSnackBarOpen(true)
      })
    })
  }

  const uploadImageProof = (data) => {
    if (data && data.length > 0) {
      var outData = data.map((dt, i) => dt && ({
        "pageNo": (i + 1),
        "pan": "", // pendingFormDetails ? pendingFormDetails.PanNo : (formValueSelector("accountDetails")(store.getState(0), "specialSegment")=="isDPOnly" && isMinorByDateSelected()) ? clientData.pan || formValueSelector("panCriteria")(store.getState(0), "pan") : formValueSelector("panCriteria")(store.getState(0), "pan"),
        "uploadId": (i + 1),
        "docTypeCode": documentTypeOption,
        "docMId": docMId,
        "type": documentUploadedFor,
        // "latitude": /* documentTypeOption == "Photo" ? geoLocationData.latitude : */ "",
        // "longitude": /* documentTypeOption == "Photo" ? geoLocationData.longitude : */ "",
        "objectionId": "",
        "fileType": dt.split(",")[0].split("/")[1].split(";")[0],
        "product": "diy",
        "base64Format": dt.split(",")[1]
      }))
      uploadDocument(outData)
    }
    setUploadPopup(false)

  }

  const uploadPdfProof = (pdfData, pdfName) => {
    setPdfPopup(false)
    var outData = [{
      "pageNo": "1",
      "pan": "", // pendingFormDetails ? pendingFormDetails.PanNo : (formValueSelector("accountDetails")(store.getState(0), "specialSegment")=="isDPOnly" && isMinorByDateSelected()) ? clientData.pan || formValueSelector("panCriteria")(store.getState(0), "pan") : formValueSelector("panCriteria")(store.getState(0), "pan"),
      "uploadId": "1",
      "docTypeCode": documentTypeOption,
      "docMId": docMId,
      "type": documentUploadedFor,
      // "latitude": /* documentTypeOption == "Photo" ? geoLocationData.latitude : */ "",
      // "longitude": /* documentTypeOption == "Photo" ? geoLocationData.longitude : */ "",
      "objectionId": "",
      "fileType": "pdf",
      "product": "diy",
      "base64Format": pdfData && pdfData.split(",")[1]
    }]
    if (pdfData !== null) {
      uploadDocument(outData)
    }
  }

  const handleEmailVerification = (e) => {
    sendEmailVerificationLink()
  }

  const contactVerification = () => {
    // console.log('OTP', otp.contactotp.length)
    if (otp.contactotp.length == 6) {
      const payload = {
        email: "",
        emailRelation: "",
        holder: "1",
        mobile: formik.values.mobile,
        mobileRelation: formik.values.mobileRelation,
        otp: otp.contactotp,
        product: "PersonalDetails"
      }
      axios.post(process.env.REACT_APP_API_URL + config.verifyOtp, payload)
        .then(resp => {
          if (resp.data.success) {
            setOpenProfilePhonePopup(!openProfilePhonePopup)
            setOtp({ ...otp, contactotp: "" });
            setResponseStatus({ "message": localeText?.DigiLockerKYCVerificationVerifiedSucc, "type": "success" })
            setSnackBarOpen(true)
            dispatch(addStageData({ ...store, MobileVerified: true }))
            // formik.setFieldValue("mobileVerified", 'Y')
            isMobileVerified = 'Y'
            oldValue.mobileRelation = formik.values.mobileRelation
          } else {
            throw new Error(resp.data.error)
          }
        }).catch((err) => {
          setResponseStatus({ "message": err.message, "type": "error" })
          setSnackBarOpen(true)
        })
    } else {
      setResponseStatus({ "message": localeText?.DigiLockerKYCVerificationValidOtp, "type": "error" })
      setSnackBarOpen(true)
    }
  }

  const sendEmailVerificationLink = () => {
    setLoader(true)
    const payload = {
      email: formik.values.email,
      emailRelation: formik.values.emailRelation,
      holder: "1",
    }
    axios.post(process.env.REACT_APP_API_URL + config.verifyEmail, payload)
      .then(resp => {
        if (resp.data.success) {
          setIsVerificationLinkSent(true)
          setLoader(false)
          setResponseStatus({ "message": localeText?.DigiLockerKYCVerificationVerificationLink, "type": "success" })
          setSnackBarOpen(true)
        } else {
          setLoader(false)
          throw new Error(resp.data.error)
        }
      }).catch((err) => {
        setResponseStatus({ "message": err.message, "type": "error" })
        setSnackBarOpen(true)
      })
  }

  const getContactVerification = () => {
    setLoader(true)
    const payload = {
      email: "",
      emailRelation: "",
      holder: "1",
      mobile: formik.values.mobile,
      mobileRelation: formik.values.mobileRelation,
      product: "PersonalDetails"
    }
    axios.post(process.env.REACT_APP_API_URL + config.validationRelation, payload).then(resp => {
      if (resp.data.success) {
        setLoader(false)
        setOpenProfilePhonePopup(!openProfilePhonePopup)
        setResponseStatus({ "message": localeText?.DigiLockerKYCVerificationOtpSend, "type": "success" })
        setSnackBarOpen(true)
      } else {
        throw new Error(resp.data.error)
      }
    }).catch((err) => {
      setLoader(false)
      setResponseStatus({ "message": err.message, "type": "error" })
      setSnackBarOpen(true)
    })
  }

  const handleContactVerification = (e) => {
    getContactVerification();
  }

  const handleCloseContactVerification = () => {
    setOpenProfilePhonePopup(!openProfilePhonePopup)
    setOtp({ ...otp, contactotp: "" });
  }

  const handleMobileChange = (e) => {
    // formik.setFieldValue("mobileVerified", 'N')
    dispatch(addStageData({ ...store, MobileVerified: false }))
    isMobileVerified = 'N'
  }

  const handleEmailChange = (e) => {
    setIsVerificationLinkSent(false)
    dispatch(addStageData({ ...store, EmailVerified: false }))
    isEmailVerified = 'N'
  }

  const handleMobileSelectChange = (e) => {
    // formik.setFieldValue("mobileVerified", 'N')
    dispatch(addStageData({ ...store, MobileVerified: false }))
    isMobileVerified = 'N'
    isMobileVerified = (e.target.value === oldValue.mobileRelation) ? 'Y' : 'N'
  }

  const handleEmailSelectChange = (e) => {
    setIsVerificationLinkSent(false)
    dispatch(addStageData({ ...store, EmailVerified: false }))
    isEmailVerified = 'N'
    isEmailVerified = (e.target.value === oldValue.emailRelation) ? 'Y' : 'N'
  }

  const handleTermsAndConditions = () =>{
    axios.get(process.env.REACT_APP_STRAPI_URL + config.customerHandout).then(resp => {
      if (resp && resp[0]?.fileUrl) {
        window.open(process.env.REACT_APP_STRAPI_URL + resp[0]?.fileUrl, "_blank")
      }
    }).catch(exception => {
      console.log(exception.msg)
    });
  }


  const handleMitcConsentClose = () => {
  setMitcConsentOpen(false);
};


const handleMtfConsentClose = () => {
  setMtfConsentOpen(false);
};


const handleDdpiConsentClose = () => {
  setDdpiConsentOpen(false);
  setisDdpiCheckedField(initialDdpiConsentCheckBox)
};


const checkSegments = () => {
  segValues=formik.values.segment
  for (let i = 0; i < segValues.length; i++) {
      if (segValues.includes(3) || segValues.includes(4) || segValues.includes(5)) {
          segFlag = false;
          break;
      }else{
          segFlag = true;
          break;
      }
  }
  return !segFlag
}
const getFilteredDocs = (id, documentData) =>{
    let filteredUploadedDocs = uploadedDocuments?.filter(item =>item.documentTypeCode !== id)
    setUploadedDocuments(filteredUploadedDocs)
}

function getIncomeProofDocumentDetails(){
  setDocumentData([])
  axios.post(process.env.REACT_APP_API_URL + config.getSegment,{})
  .then(response => {
      setDocumentData(response.data.success?.documentList)
  })
  .catch(exception => {
      console.log(exception)
  })
}


const onConsentChange = (key, value) => {
  if(key == "pastAction" && !value){
      setCheckedField({
          ...checkedField,
          "pastActionReason": "",
          [key]: value
      });
  }
  else{
      setCheckedField({
          ...checkedField,
          [key]: value
      });
  }
};


  const handleConsentClose = () => {
    setConsentOpen(false);
    var tempInitialConsentCheckBox = initialConsentCheckBox;
    tempInitialConsentCheckBox["authRunningAccount"] = checkedField?.authRunningAccount
    setCheckedField(tempInitialConsentCheckBox)
  };

  const panDetails = () => {
    return (
      <Grid container item xs={12} spacing="12" css={{ marginTop: "5px" }}>
        <Grid item xs={12} md={3}>
          <StyledTextField
            id="pan"
            name="pan"
            css={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            required
            value={formik.values.pan?.toUpperCase()}
            inputProps={{ maxLength: 10 }}
            fullWidth
            label={localeText?.kycVerificationNumber}
            variant="outlined"
            onChange={(e) => {
               handleChangePan(e);
               formik.handleChange(e)
               formik.setFieldValue('pan', e?.currentTarget?.value?.toUpperCase())
              }}
            disabled={(store?.digilockerData?.pan != "")}
          />
        </Grid>
        {/* {!isEdit && <Grid item xs={12} md={3}>
          <StyledTextField
            id="email"
            name="email"
            css={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            value={formik.values.email}
            fullWidth
            label={"Email ID"}
            variant="outlined"
            required
            disabled
            onChange={formik.handleChange}
          />
        </Grid>} */}
          <Grid item xs={12} md={3}>
          <StyledTextField id="firstName" name="firstName" css={{ marginTop: "10px" }}
            InputLabelProps={{
              shrink: true,
            }}
            required
            value={(formik.values.firstName)?.toUpperCase()}
            error={formik.touched.firstName && Boolean(formik.errors.firstName)}
            helperText={formik.touched.firstName && formik.errors.firstName}
            inputProps={{ maxLength: 100 }} fullWidth
            label={localeText?.kycFirstNameAsPerPan} variant="outlined"
            // onChange={formik.handleChange}
            onChange={(e) => {
              formik.handleChange(e)
              formik.setFieldValue('firstName', e.currentTarget.value)
            }}
            disabled={isDigilockerFailed ? false : (store?.digilockerData?.pan != "")}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <StyledTextField id="middleName" name="middleName" css={{ marginTop: "10px" }}
            InputLabelProps={{
              shrink: true,
            }}
            // required
            value={(formik.values.middleName)?.toUpperCase()}
            error={formik.touched.middleName && Boolean(formik.errors.middleName)}
            helperText={formik.touched.middleName && formik.errors.middleName}
            inputProps={{ maxLength: 100 }} fullWidth
            label={localeText?.kycMiddleNameAsPerPan} variant="outlined"
            // onChange={formik.handleChange}
            onChange={(e) => {
              formik.handleChange(e)
              formik.setFieldValue('middleName', e.currentTarget.value)
            }}
            disabled={isDigilockerFailed ? false : (store?.digilockerData?.pan != "")}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <StyledTextField id="lastName" name="lastName" css={{ marginTop: "10px" }}
            InputLabelProps={{
              shrink: true,
            }}
            // required
            value={(formik.values.lastName)?.toUpperCase()}
            error={formik.touched.lastName && Boolean(formik.errors.lastName)}
            helperText={formik.touched.lastName && formik.errors.lastName}
            inputProps={{ maxLength: 100 }} fullWidth
            label={localeText?.kycLastNameAsPerPan} variant="outlined"
            // onChange={formik.handleChange}
            onChange={(e) => {
              formik.handleChange(e)
              formik.setFieldValue('lastName', e.currentTarget.value)
            }}
            disabled={isDigilockerFailed ? false : (store?.digilockerData?.pan != "")}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker css={{ width: "100%", marginTop: "10px" }}
              inputFormat="DD/MM/YYYY"
              id="dateofBirth"
              views={['year', 'month', 'day']}
              name="dateofBirth"
              value={formik.values.dateofBirth}
              maxDate={new Date()}
              label={localeText?.kycVerificationDate}
              onChange={e => {
                formik.setFieldValue("dateofBirth", e?.$d ? new Date(e?.$d).getTime(): new Date().getTime())
              }}
              renderInput={(params) => <StyledTextField
                fullWidth
                required
                error={formik.touched.dateofBirth && Boolean(formik.errors.dateofBirth)}
                helperText={formik.touched.dateofBirth && formik.errors.dateofBirth}
                {...params}
              />}
              disabled={isDigilockerFailed ? false : (store?.digilockerData?.pan != "")}
            />
          </LocalizationProvider>
        </Grid>
        {/* !isEdit &&  */<Grid item xs={12} md={3}>
          <StyledTextField
            id="gender"
            name="gender"
            css={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            value={formik.values.gender ? (formik.values.gender === "M" ? "Male" : formik.values.gender === "F" ? "Female" : "Transgender") : ""}
            fullWidth
            label={localeText?.DigiLockerKYCVerificationGender}
            variant="outlined"
            required
            disabled
            onChange={formik.handleChange}
          />
        </Grid>}
        <Grid item md={3} xs={12}>
          <FormGroup css={{ border: "1px solid #D0D0D0", marginTop: "9px", borderRadius: "3px" }} key={formik.values.isIndian}>
            <FormControlLabel control={<Checkbox css={{ marginLeft: "20px", padding: "7px" }} name="isIndian" id="isIndian" checked={formik.values.isIndian} onChange={e => formik.setFieldValue("isIndian", e.currentTarget.checked)} />}
              label={localeText?.kycVerificationResident}
            />
          </FormGroup>
        </Grid>
        <Grid item xl={0.5} lg={0.5} md={1} xs={12}>
          <Button variant='contained' color="primary" css={{ marginTop: "10px" }} onClick={handleToggleInfoPopup}>
            <InfoOutlinedIcon/>
          </Button>
        </Grid>
      </Grid>
    )
  }

  const segments = () => {
    return (
      <Grid container item xs={12} spacing="12" css={{ marginTop: "5px" }}>
        <Grid item xs={12} css={{ fontWeight: "bold" }}>
          {localeText?.DigiLockerKYCVerificationSegments}
        </Grid>
        <Grid item xs={12} css={{ textTransform: "none", textAlign: isSmallScreen ? "center" : "none" }}>
          <FormControl error={formik.touched.segment && Boolean(formik.errors.segment)} >
            <ToggleButtonGroup
              orientation={isSmallScreen ? "vertical" : "horizontal"}
              value={formik.values.segment}
              id="segment"
              // disabled={disableAllFields}
              name="segment"
              onChange={(e, value) => {
                if (value && value.includes(1) && value.includes(2)) {
                  formik.setFieldValue("segment", value)
                }
              }}
              color="primary"
            >
              {segmentOptions.sort((a, b) => a.id - b.id).map(segment =>
                <ToggleButton value={segment.id} css={{ textTransform: "none" }}>
                  {segment.segmentDescription || ''}
                </ToggleButton>
              )}
            </ToggleButtonGroup>
            <FormHelperText>{formik.touched.segment && formik.errors.segment}</FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Typography display={"inline"} variant='body2' css={{ fontWeight: "bold" }}>
            {localeText?.DigiLockerKYCVerificationNote}
          </Typography>
          <Typography display={"inline"} variant='body2'>
            {<i>{localeText?.DigiLockerKYCVerificationIncomeProof}</i>}
          </Typography>
        </Grid>
        <Grid item xs={12}>
            {
                checkSegments() && documentData &&
                <Upload
                    masterId={documentData?.find(document => document?.documentTypeCode == "InPr")?.id}
                    title={localeText?.UploadIncome}
                    documentOptionData={{ id: "InPr", type: "holder1", code: "InPr", screen: "kyc" }}
                    setUploadedDocuments={(data) => setUploadedDocuments([...uploadedDocuments, ...data])}
                    uploadedDocuments={uploadedDocuments.filter(doc => doc.documentTypeCode == 'InPr')}
                    
                    documentData={documentData}
                    setDocumentData={setDocumentData}
                    getFilteredDocs={getFilteredDocs}

                    isRequired={true}
                />
            }
        </Grid>
      </Grid>
    )
  }

  const handleAgreementOfConsents = (e, type) => {
    if (type === 'consent') {
      formik.setFieldValue("isAgreeToTerms", e.currentTarget.checked)
      formik.setFieldValue("isAgreeToConcent", e.currentTarget.checked)
      formik.setFieldValue("isAgreeMITC", e.currentTarget.checked)
      formik.setFieldValue("isDDPIConsent", e.currentTarget.checked)
      formik.setFieldValue("isMTFDeclaration", e.currentTarget.checked)
    } else if (type === "isAgreeToConcent") {
      formik.setFieldValue("isAgreeToConcent", e.currentTarget.checked)
    } else if (type === "mitcConsent") {
      formik.setFieldValue("isAgreeMITC", e.currentTarget.checked)
    } else if (type === "ddpiConsent") {
      formik.setFieldValue("isDDPIConsent", e.currentTarget.checked)
    } else if (type === "mtfConsent") {
      formik.setFieldValue("isMTFDeclaration", e.currentTarget.checked)
    }
  }

  const handleAgreementOfConsentsOpen = (e, type) => {
    if (type === 'consent') {
        setConsentOpen(true);
    } else if (type === "mitcConsent") {
        setMitcConsentOpen(true);
    } else if (type === "ddpiConsent") {
        setDdpiConsentOpen(true);
    } else if (type === "mtfConsent") {
        setMtfConsentOpen(true);
    }
  }

  const onDdpiConsentChange = (key, value) => {
    setisDdpiCheckedField({
        ...isDdpiCheckedField,
        [key]: value
    });
  };

  const getLastDateOfFinancialYear = () => {
    const currentMonth = new Date().getMonth();
    const networthDate = new Date(currentMonth>2 ? (new Date().getFullYear()) : (new Date().getFullYear()-1), 2, 31).getTime();
    return networthDate
  };

  const generateEmailLink = () => {
    getContactVerificationDetails()
    setGenerateLink(true)
  }

  const changeNatureOfBusinessOthers=(e, dependentChange)=>{
    var otherData = fatcaOptions?.occupationList.find(occupation=> occupation.id == (dependentChange ? e.target.value : formik.values.occupation));
    formik.setFieldValue("natureOfBusinessOther", ((dependentChange ? formik.values.natureOfBusiness == 5 : e.target.value == 5) && !otherData?.isOtherAllowed) ?  otherData?.occupationName : "")
  }

  const personalDetails = () => {
    return (
      <Grid container item xs={12} spacing="12" css={{ marginTop: "5px" }}>
        {isEdit ?
          <>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12} css={{ fontWeight: "bold" }}>
              {localeText?.DigiLockerKYCVerificationPersonalDetail}
            </Grid>
          </>
          :
          <></>
        }
        <Grid container item xs={12} lg={8} md={12} spacing="12" css={{ marginTop: "5px" }}>
          <Grid container item xs={12} spacing={3}>
            <Grid item css={{ fontWeight: "bold", alignSelf: "center" }}>
              {localeText?.DigiLockerKYCVerificationRelation}
            </Grid>
            <Grid item>
              <FormControl
                id="fatherOrSpouse"
                name="fatherOrSpouse"
                error={formik.touched.fatherOrSpouse && Boolean(formik.errors.fatherOrSpouse)}>
                <RadioGroup value={formik.values.fatherOrSpouse} row name="row-radio-buttons-group" onChange={(e, value) => { formik.setFieldValue("fatherOrSpouse", value) }}>
                  <FormControlLabel value="Father" control={<Radio size='small' />} label={localeText?.DigiLockerKYCVerificationFather} />
                  <FormControlLabel value="Spouse" control={<Radio size='small' />} label={localeText?.DigiLockerKYCVerificationSpouse} />
                </RadioGroup>
                <FormHelperText>{formik.touched.fatherOrSpouse && formik.errors.fatherOrSpouse}</FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <StyledTextField
              id="fathersSpouseFirstName"
              name="fathersSpouseFirstName"
              css={{ marginTop: "10px" }}
              InputLabelProps={{ shrink: true }}
              required
              value={(formik.values.fathersSpouseFirstName)?.toUpperCase()}
              error={formik.touched.fathersSpouseFirstName && Boolean(formik.errors.fathersSpouseFirstName)}
              helperText={formik.touched.fathersSpouseFirstName && formik.errors.fathersSpouseFirstName}
              fullWidth
              label={localeText?.DigiLockerKYCVerificationFirstName}
              variant="outlined"
              // disabled={!isEdit}
              onChange={formik.handleChange}
            />
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <StyledTextField
              id="fathersSpouseMiddleName"
              name="fathersSpouseMiddleName"
              css={{ marginTop: "10px" }}
              InputLabelProps={{ shrink: true }}
              value={(formik.values.fathersSpouseMiddleName)?.toUpperCase()}
              error={formik.touched.fathersSpouseMiddleName && Boolean(formik.errors.fathersSpouseMiddleName)}
              helperText={formik.touched.fathersSpouseMiddleName && formik.errors.fathersSpouseMiddleName}
              fullWidth
              label={localeText?.DigiLockerKYCVerificationMiddleName}
              variant="outlined"
              // disabled={!isEdit}
              onChange={formik.handleChange}
            />
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <StyledTextField
              id="fathersSpouseLastName"
              name="fathersSpouseLastName"
              css={{ marginTop: "10px" }}
              InputLabelProps={{ shrink: true }}
              // required
              value={(formik.values.fathersSpouseLastName)?.toUpperCase()}
              error={formik.touched.fathersSpouseLastName && Boolean(formik.errors.fathersSpouseLastName)}
              helperText={formik.touched.fathersSpouseLastName && formik.errors.fathersSpouseLastName}
              fullWidth
              label={localeText?.DigiLockerKYCVerificationLastName}
              variant="outlined"
              // disabled={!isEdit}
              onChange={formik.handleChange}
            />
          </Grid>
        </Grid>
        <Grid container item xs={12} lg={4} md={12} spacing="12" css={{ marginTop: "6px", alignSelf: "flex-end" }}>
          <Grid item xs={12} css={{ fontWeight: "bold" }}>
            {localeText?.DigiLockerKYCVerificationMaritalStatus} *
          </Grid>
          <Grid item xs={12} css={{ textTransform: "none" }}>
            <FormControl error={formik.touched.maritialStatus && Boolean(formik.errors.maritialStatus)}>
              <ToggleButtonGroup
                value={formik.values.maritialStatus}
                exclusive
                id="maritialStatus"
                name="maritialStatus"
                // disabled={!isEdit}
                onChange={(e, value) => { formik.setFieldValue("maritialStatus", value || "") }}
                color="primary"
              >
                <ToggleButton value="Single" css={{ textTransform: "none", padding: "8px" }}>
                  {localeText?.DigiLockerKYCVerificationSingle}
                </ToggleButton>
                <ToggleButton value="Married" css={{ textTransform: "none", padding: "8px" }}>
                  {localeText?.DigiLockerKYCVerificationMarried}
                </ToggleButton>
              </ToggleButtonGroup>
              <FormHelperText>{formik.touched.maritialStatus && formik.errors.maritialStatus}</FormHelperText>
            </FormControl>

          </Grid>
        </Grid>

        {
          <Grid container item xs={12} spacing="12" css={{ marginTop: "5px" }}>
            <Grid item xs={12} css={{ fontWeight: "bold", alignSelf: "center" }}>
              {localeText?.DigiLockerKYCVerificationContactDetails}
            </Grid>
            <Grid item xs={12} md={6} lg={2.5}>
              <StyledTextField
                id="mobile"
                name="mobile"
                css={{ marginTop: "10px" }}
                InputLabelProps={{ shrink: true }}
                value={formik.values.mobile}
                error={formik.touched.mobile && Boolean(formik.errors.mobile)}
                helperText={formik.touched.mobile && formik.errors.mobile}
                fullWidth
                label={localeText?.DigiLockerKYCVerificationMobileNumber} variant="outlined"
                inputProps={{ maxLength: 10 }}
                // disabled
                min={0}
                required
                onChange={(e) => {
                  handleMobileChange(e)
                  formik.handleChange(e)
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3} sx={{ display: "flex" }}>
              <FormControl /* disabled={!isEdit} */ required fullWidth error={formik.touched.mobileRelation && Boolean(formik.errors.mobileRelation)} css={{ marginTop: "10px" }}>
                <InputLabel
                  shrink
                >
                  {localeText?.DigiLockerKYCVerificationMobileRelation}
                </InputLabel>
                <Select
                  id="mobileRelation"
                  name="mobileRelation"
                  value={formik.values.mobileRelation}
                  size="small"
                  required
                  onChange={(e) => {
                    handleMobileSelectChange(e)
                    formik.handleChange(e)
                  }}
                  input={
                    <OutlinedInput
                      notched
                      label={localeText?.DigiLockerKYCVerificationMobileRelation}
                    />
                  }
                >
                  <MenuItem value="">{localeText?.DigiLockerKYCVerificationSelectValue}</MenuItem>
                  {options.filter(opt => opt.relationType == "Mobile").map(opt => <MenuItem value={opt.relationship}>{opt.relationship}</MenuItem>)}
                </Select>
                <FormHelperText>{formik.touched.mobileRelation && formik.errors.mobileRelation}</FormHelperText>
                {isMobileVerified === 'Y' ? <Typography variant="body2"><CheckCircleOutlineIcon css={{ color: "green", verticalAlign: "middle" }} />{localeText?.DigiLockerKYCVerificationVerified}</Typography> : <Typography variant="body2" ><HighlightOffIcon css={{ color: "red", verticalAlign: "middle" }} />{localeText?.DigiLockerKYCVerificationUnVerified}</Typography>}

              </FormControl>
              {
                <Grid item css={{ marginTop: "13px", marginLeft: "5px", fontSize: "12px", paddingBottom: "30px" }}>
                  <Button variant='contained' color="secondary" sx={{ width: 20, fontSize: "12px" }}
                    disabled={isMobileVerified === 'Y' || !formik.values.mobileRelation} onClick={handleContactVerification}>
                    {localeText?.DigiLockerKYCVerificationVerify}
                  </Button>
                </Grid>
              }


            </Grid>
            <Grid item xs={12} md={6} lg={2.5}>
              <StyledTextField
                id="email"
                name="email"
                css={{ marginTop: "10px" }}
                InputLabelProps={{ shrink: true }}
                value={formik.values.email}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                fullWidth
                label={localeText?.DigiLockerKYCVerificationEmailId}
                variant="outlined"
                required
                // disabled={!isEdit}
                onChange={(e) => {
                  handleEmailChange(e)
                  formik.handleChange(e)
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3} sx={{ display: "flex" }}>
              <FormControl /* disabled={!isEdit} */ required fullWidth error={formik.touched.emailRelation && Boolean(formik.errors.emailRelation)} css={{ marginTop: "10px" }}>
                <InputLabel shrink>{localeText?.DigiLockerKYCVerificationEmailRelation}</InputLabel>
                <Select
                  id="emailRelation"
                  name="emailRelation"
                  value={formik.values.emailRelation}
                  size="small"
                  onChange={(e) => {
                    handleEmailSelectChange(e)
                    formik.handleChange(e)
                  }}
                  input={
                    <OutlinedInput
                      notched
                      label={localeText?.DigiLockerKYCVerificationEmailRelation}
                    />
                  }
                >
                  <MenuItem value="">{localeText?.DigiLockerKYCVerificationSelectValue}</MenuItem>
                  {options.filter(opt => opt.relationType == "Email").map(opt => <MenuItem value={opt.relationship}>{opt.relationship}</MenuItem>)}
                </Select>
                <FormHelperText>{formik.touched.emailRelation && formik.errors.emailRelation}</FormHelperText>
                {isEmailVerified === 'Y' ?
                  <Typography variant="body2"><CheckCircleOutlineIcon css={{ color: "green", verticalAlign: "middle" }} />{localeText?.DigiLockerKYCVerificationVerified}</Typography>
                  : isVerificationLinkSent ? <Typography variant="body2" color="secondary">{localeText?.DigiLockerKYCVerificationCheckMailBox}</Typography>
                    : <Typography variant="body2"><HighlightOffIcon css={{ color: "red", verticalAlign: "middle" }} />{localeText?.DigiLockerKYCVerificationUnVerified}</Typography>}
              </FormControl>

              {
                isVerificationLinkSent ?
                  <Grid item css={{ marginTop: "13px", marginLeft: "5px", fontSize: "12px", display: isEmailVerified === 'Y' && "none" }}>
                    <Button variant='contained' color="secondary" sx={{ fontSize: "12px" }} onClick={generateEmailLink}>
                      {
                        refresh ? <CircularProgress size={20} sx={{ color: 'white' }} /> : localeText?.DigiLockerKYCVerificationRefresh
                      }
                    </Button>
                    {
                      generateLink &&
                      <Typography css={{ cursor: "pointer", fontSize: "14px", textAlign: "center", marginTop: "8px", color: "#24B7CC" }}>
                        {loader ? <TextLoader name={localeText?.profileLoading} /> : <Link onClick={handleEmailVerification}>{localeText?.landingResend}</Link>}
                      </Typography>
                    }

                  </Grid>
                  :
                  <Grid item css={{ marginTop: "13px", marginLeft: "5px", fontSize: "12px" }}>
                    <Button variant='contained' color="secondary" sx={{ fontSize: "12px" }}
                      disabled={isEmailVerified === 'Y' || !formik.values.emailRelation} onClick={handleEmailVerification}>
                      {
                        loader ? <CircularProgress size={20} sx={{ color: 'white' }} /> : localeText?.DigiLockerKYCVerificationVerify
                      }
                    </Button>
                  </Grid>
              }
            </Grid>
          </Grid>
        }
      </Grid>
    )
  }

  const addressDetails = () => {
    return (
      <Grid container item xs={12} spacing={3} css={{ marginTop: "5px", alignSelf: "flex-start" }}>
        {isEdit &&
            <Grid item xs={12}>
              <Divider />
            </Grid>
        }
        <>
            <Grid container item xs={12} lg={12} xl={6} md={12} spacing="12" css={{ marginTop: "5px" }}>
              <Grid item xs={12} css={{ fontWeight: "bold" }}>
                {localeText?.DigiLockerKYCVerificationCorrespondenceAdd}
              </Grid>
              <Grid item xs={12} md={6}>
                <StyledTextField
                  id="addressLine1"
                  name="addressLine1"
                  css={{ marginTop: "10px" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={(formik.values.addressLine1)?.toUpperCase()}
                  inputProps={{ maxLength: 50 }}
                  fullWidth
                  label={localeText?.DigiLockerKYCVerificationFlatNo}
                  variant="outlined"
                  disabled={!isEdit}
                  onChange={e => { handleSameAsCorrespondenceChecked(e, "perAddressLine1"); formik.handleChange(e) }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <StyledTextField
                  id="addressLine2"
                  name="addressLine2"
                  css={{ marginTop: "10px" }}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 50 }}
                  value={(formik.values.addressLine2)?.toUpperCase()}
                  fullWidth
                  label={localeText?.DigiLockerKYCVerificationColony}
                  variant="outlined"
                  disabled={!isEdit}
                  onChange={e => { handleSameAsCorrespondenceChecked(e, "perAddressLine2"); formik.handleChange(e) }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <StyledTextField
                  id="addressLine3"
                  name="addressLine3"
                  css={{ marginTop: "10px" }}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 50 }}
                  value={(formik.values.addressLine3)?.toUpperCase()}
                  fullWidth
                  label={localeText?.DigiLockerKYCVerificationTown}
                  variant="outlined"
                  disabled={!isEdit}
                  onChange={e => { handleSameAsCorrespondenceChecked(e, "perAddressLine3"); formik.handleChange(e) }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  css={{ marginTop: "10px" }}
                  id="pincode"
                  name="pincode"
                  value={formik.values.pincode}
                  open={open?.corr}
                  onOpen={() => {
                    setOpen({ ...open, corr: true });
                  }}
                  onClose={() => {
                    setOpen({ ...open, corr: false });
                  }}
                  disabled={!isEdit}
                  options={pincodeOptions}
                  disablePortal
                  filterOptions={(x) => x}
                  loading={open?.corr && pincodeOptions.length == 0}
                  renderOption={(props, searchedItem, state) => {
                    return getOptionComponent(searchedItem, "corr")
                  }}
                  isOptionEqualToValue={(option, value) => { return option.pinCode === value }}
                  getOptionLabel={(option) => { return option }}
                  renderInput={(params) => <StyledTextField {...params} fullWidth variant="outlined" label={localeText?.DigiLockerKYCVerificationPin}
                    onChange={e => handlePincodeSearch(e, "corr")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    size="small"
                    id="pincode"
                    name="pincode"
                  />}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <StyledTextField
                  id="state"
                  name="state"
                  css={{ marginTop: "10px" }}
                  InputLabelProps={{ shrink: true }}
                  value={(formik.values.state)?.toUpperCase()}
                  fullWidth
                  label={localeText?.DigiLockerKYCVerificationSt}
                  variant="outlined"
                  disabled
                  onChange={e => { handleSameAsCorrespondenceChecked(e, "PerState"); formik.handleChange(e) }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <StyledTextField
                  id="city"
                  name="city"
                  css={{ marginTop: "10px" }}
                  InputLabelProps={{ shrink: true }}
                  value={(formik.values.city)?.toUpperCase()}
                  fullWidth
                  label={localeText?.DigiLockerKYCVerificationCi}
                  variant="outlined"
                  disabled
                  onChange={e => { handleSameAsCorrespondenceChecked(e, "perCity"); formik.handleChange(e) }}
                />
              </Grid>
              {isEdit && <Grid item xs={12}>
                <Upload
                  masterId={'3'}
                  title={localeText?.DigiLockerKYCVerificationProof}
                  documentOptionData={{ id: "CPOA", type: "holder1", code: "CPOA", screen: "" }}
                  setUploadedDocuments={(data) => setUploadedDocuments([...uploadedDocuments, ...data])}
                  uploadedDocuments={uploadedDocuments.filter(doc => doc.documentTypeCode == 'CPOA')}
                />
              </Grid>}
            </Grid>
            <Grid container item xs={12} xl={6} md={12} spacing="12" css={{ marginTop: "5px", alignSelf: "flex-start" }}>
              <Grid container item xs={12} css={{ fontWeight: "bold", marginRight: "10px" }}>
                <Grid item css={{ fontWeight: "bold" }}>
                  <Typography display="inline" fontWeight={"bold"}>
                    {localeText?.DigiLockerKYCVerificationPermanentAddress}
                  </Typography>
                </Grid>
                <Grid item css={{ marginLeft: "10px" }}>
                  <FormControl disabled={!isEdit}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          css={{ padding: 0, marginRight: "5px" }}
                          name="isPermanentAddressSameasCorrespondence"
                          id="isPermanentAddressSameasCorrespondence"
                          checked={formik.values.isPermanentAddressSameasCorrespondence}
                          onChange={e => { handleSameAsCorrAddress(e); formik.setFieldValue("isPermanentAddressSameasCorrespondence", e.currentTarget.checked) }}
                        />}
                      label={<Typography variant='body2'>{localeText?.DigiLockerKYCVerificationPermanentSame} </Typography>}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <StyledTextField
                  id="perAddressLine1"
                  name="perAddressLine1"
                  css={{ marginTop: "10px" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{ maxLength: 50 }}
                  value={(formik.values.perAddressLine1)?.toUpperCase()}
                  fullWidth
                  label={localeText?.DigiLockerKYCVerificationFlatNo}
                  variant="outlined"
                  onChange={formik.handleChange}
                  disabled={formik.values.isPermanentAddressSameasCorrespondence || !isEdit}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <StyledTextField
                  id="perAddressLine2"
                  name="perAddressLine2"
                  css={{ marginTop: "10px" }}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 50 }}
                  value={(formik.values.perAddressLine2)?.toUpperCase()}
                  fullWidth
                  label={localeText?.DigiLockerKYCVerificationColony}
                  variant="outlined"
                  onChange={formik.handleChange}
                  disabled={formik.values.isPermanentAddressSameasCorrespondence || !isEdit}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <StyledTextField
                  id="perAddressLine3"
                  name="perAddressLine3"
                  css={{ marginTop: "10px" }}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 50 }}
                  value={(formik.values.perAddressLine3)?.toUpperCase()}
                  fullWidth
                  label={localeText?.DigiLockerKYCVerificationTown}
                  variant="outlined"
                  onChange={formik.handleChange}
                  disabled={formik.values.isPermanentAddressSameasCorrespondence || !isEdit}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  css={{ marginTop: "10px" }}
                  id="perPincode"
                  name="perPincode"
                  value={formik.values.perPincode}
                  open={open?.perm}
                  onOpen={() => {
                    setOpen({ ...open, perm: true });
                  }}
                  onClose={() => {
                    setOpen({ ...open, perm: false });
                  }}
                  disabled={formik.values.isPermanentAddressSameasCorrespondence || !isEdit}
                  options={pincodeOptions}
                  disablePortal
                  filterOptions={(x) => x}
                  loading={open?.perm && pincodeOptions.length == 0}
                  renderOption={(props, searchedItem, state) => {
                    return getOptionComponent(searchedItem, "perm")
                  }}
                  isOptionEqualToValue={(option, value) => { return option.pinCode === value }}
                  getOptionLabel={(option) => { return option }}
                  renderInput={(params) => <StyledTextField {...params}
                    fullWidth
                    variant="outlined"
                    label={localeText?.DigiLockerKYCVerificationPin}
                    onChange={e => handlePincodeSearch(e, "perm")}
                    id="perPincode" name="perPincode"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    size="small"
                  />}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <StyledTextField
                  id="PerState"
                  name="PerState"
                  css={{ marginTop: "10px" }}
                  InputLabelProps={{ shrink: true }}
                  value={(formik.values.PerState)?.toUpperCase()}
                  fullWidth
                  label={localeText?.DigiLockerKYCVerificationSt}
                  variant="outlined"
                  disabled
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <StyledTextField
                  id="perCity"
                  name="perCity"
                  css={{ marginTop: "10px" }}
                  InputLabelProps={{ shrink: true }}
                  value={(formik.values.perCity)?.toUpperCase()}
                  fullWidth
                  label={localeText?.DigiLockerKYCVerificationCi}
                  variant="outlined"
                  disabled
                  onChange={formik.handleChange}
                />
              </Grid>
              {(isEdit && !formik.values.isPermanentAddressSameasCorrespondence) && <Grid item xs={12}>
                <Upload
                  masterId={'2'}
                  title={localeText?.DigiLockerKYCVerificationProof}
                  documentOptionData={{ id: "PPOA", type: "holder1", code: "PPOA", screen: "" }}
                  setUploadedDocuments={(data) => setUploadedDocuments([...uploadedDocuments, ...data])}
                  uploadedDocuments={uploadedDocuments.filter(doc => doc.documentTypeCode == 'PPOA')}
                />
              </Grid>}
            </Grid>
          </>
      </Grid>
    )
  }

  const handleAnnualIncomeRange = (e) => {
    formik.setFieldValue("anualIncomeRange", e.target.value)
    if (e.target.value === 1) {
      formik.setFieldValue("networth", 100000)
    } else if (e.target.value === 2) {
      formik.setFieldValue("networth", 1000000)
    } else if (e.target.value === 3) {
      formik.setFieldValue("networth", 5000000)
    } else if (e.target.value === 4) {
      formik.setFieldValue("networth", 10000000)
    } else if (e.target.value === 5) {
      formik.setFieldValue("networth", 25000000)
    } else {
      formik.setFieldValue("networth", "")
    }
  }

  const fatcaDetails = () => {
    return (
      <Grid container item xs={12} spacing="12" css={{ marginTop: "5px" }}>
        {isEdit && <Grid item xs={12} css={{ fontWeight: "bold", alignSelf: "center" }}>
          <Divider />
        </Grid>}
        <Grid item xs={12} css={{ fontWeight: "bold" }}>
          {localeText?.DigiLockerKYCVerificationFatca}
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl required fullWidth error={formik.touched.anualIncomeRange && Boolean(formik.errors.anualIncomeRange)} css={{ marginTop: "10px" }}>
            <InputLabel shrink>{localeText?.DigiLockerKYCVerificationSelectRange}</InputLabel>
            <Select
              id="anualIncomeRange"
              name="anualIncomeRange"
              value={formik.values.anualIncomeRange}
              onChange={e => handleAnnualIncomeRange(e)}
              size="small"
              input={
                <OutlinedInput
                  notched
                  label={localeText?.DigiLockerKYCVerificationSelectRange}
                />
              }
            >
              <MenuItem value="">{"- Select value -"}</MenuItem>
              {fatcaOptions?.annualIncomeSlabList?.map(opt => <MenuItem value={opt.id}>{opt.slabRange}</MenuItem>)}
            </Select>
            <FormHelperText>{formik.touched.anualIncomeRange && formik.errors.anualIncomeRange}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <StyledTextField id="networth" name="networth" css={{ marginTop: "10px" }}
            label={localeText?.AddressNetWorth} variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            required
            // inputProps={{ maxLength: 2 }}
            value={formik.values.networth}
            error={formik.touched.networth && Boolean(formik.errors.networth)}
            helperText={formik.touched.networth && formik.errors.networth} fullWidth
            onChange={formik.handleChange}
          />
          {formik.values.networth && (
            <div style={{ color: 'gray', marginTop: '5px' }}>
              {incomeNetWorthMapping[formik.values.anualIncomeRange]?.suggestionText}
            </div>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={localeText?.AddressNetWorthAsOnDate}
              css={{ width: "100%", marginTop: "10px" }}
              inputFormat="DD/MM/YYYY"
              id="networthDate"
              views={['year', 'month', 'day']}
              name="networthDate"
              value={formik.values.networthDate}
              onChange={e => {
                formik.setFieldValue("networthDate", getLastDateOfFinancialYear());
              }}
              disabled={true}
              renderInput={(params) => (
                <StyledTextField
                  fullWidth
                  required
                  error={formik.touched.networthDate && Boolean(formik.errors.networthDate)}
                  helperText={formik.touched.networthDate && formik.errors.networthDate}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl required fullWidth error={formik.touched.occupation && Boolean(formik.errors.occupation)} css={{ marginTop: "10px" }}>
            <InputLabel shrink>{localeText?.DigiLockerKYCVerificationSelectOccupation}</InputLabel>
            <Select
              id="occupation"
              name="occupation"
              value={formik.values.occupation}
              onChange={e => {changeNatureOfBusinessOthers(e, true); formik.handleChange(e)}}
              size="small"
              input={
                <OutlinedInput
                  notched
                  label={localeText?.DigiLockerKYCVerificationSelectOccupation}
                />
              }
            >
              <MenuItem value="">{localeText?.DigiLockerKYCVerificationSelectValue}</MenuItem>
              {fatcaOptions?.occupationList?.filter(opt => !opt.isParent)?.map(opt => <MenuItem value={opt.id}>{opt.occupationName}</MenuItem>)}
            </Select>
            <FormHelperText>{formik.touched.occupation && formik.errors.occupation}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl required fullWidth error={formik.touched.natureOfBusiness && Boolean(formik.errors.natureOfBusiness)} css={{ marginTop: "10px" }}>
            <InputLabel
              shrink
            >
              {localeText?.DigiLockerKYCVerificationSelectNature}
            </InputLabel>
            <Select
              id="natureOfBusiness"
              name="natureOfBusiness"
              value={formik.values.natureOfBusiness}
              onChange={ (e)=>{formik.setFieldValue("natureOfBusinessOther", fatcaOptions?.occupationList.find(occupation => occupation.id == formik?.values?.occupation)?.isOtherAllowed ? "": fatcaOptions?.occupationList.find(occupation=> occupation.id == formik?.values?.occupation)?.occupationName); formik.handleChange(e)}}
              size="small"
              input={
                <OutlinedInput
                  notched
                  label={localeText?.DigiLockerKYCVerificationSelectNature}
                />
              }
            >
              <MenuItem value="">{localeText?.AddressSelect}</MenuItem>
              {fatcaOptions?.occupationList.find(occupation => occupation.id == formik?.values?.occupation)?.natureOfBusinessList?.map(opt => <MenuItem value={opt.id}>{opt.natureOfBusinessDesc}</MenuItem>)}
            </Select>
            <FormHelperText>{formik.touched.natureOfBusiness && formik.errors.natureOfBusiness}</FormHelperText>
          </FormControl>
        </Grid>
        {formik.values.natureOfBusiness == 5 && <Grid item xs={12} md={6}>
        <StyledTextField id="natureOfBusinessOther" name="natureOfBusinessOther" css={{ marginTop: "10px" }}
            InputLabelProps={{
                shrink: true,
            }}
            required
            disabled ={!(fatcaOptions?.occupationList.find(occupation=> occupation.id == formik?.values?.occupation).isOtherAllowed)}
            value={formik?.values?.natureOfBusinessOther}
            error={formik.touched.natureOfBusinessOther && Boolean(formik.errors.natureOfBusinessOther)}
            helperText={formik.touched.natureOfBusinessOther && formik.errors.natureOfBusinessOther} fullWidth
            label={localeText?.DigiLockerKYCVerificationOther} variant="outlined"
            onChange={formik.handleChange}
        />
    </Grid>}
        <Grid item xs={12} md={6}>
          <StyledTextField
            id="tradingExp"
            name="tradingExp"
            css={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            inputProps={{ maxLength: 2 }}
            value={formik.values.tradingExp}
            error={formik.touched.tradingExp && Boolean(formik.errors.tradingExp)}
            helperText={formik.touched.tradingExp && formik.errors.tradingExp}
            fullWidth
            label={localeText?.DigiLockerKYCVerificationTrading}
            variant="outlined"
            onChange={formik.handleChange}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl required fullWidth error={formik.touched.politicalAffiliations && Boolean(formik.errors.politicalAffiliations)} css={{ marginTop: "10px" }}>
            <InputLabel shrink>{localeText?.DigiLockerKYCVerificationAffiliations}</InputLabel>
            <Select
              id="politicalAffiliations"
              name="politicalAffiliations"
              value={formik.values.politicalAffiliations}
              onChange={formik.handleChange}
              size="small"
              input={
                <OutlinedInput
                  notched
                  label={localeText?.DigiLockerKYCVerificationAffiliations}
                />
              }
            >
              <MenuItem value="">{"- Select value -"}</MenuItem>
              {fatcaOptions?.pepStatusList?.map(opt => <MenuItem value={opt.Code}>{opt.Description}</MenuItem>)}
            </Select>
            <FormHelperText>{formik.touched.politicalAffiliations && formik.errors.politicalAffiliations}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl required fullWidth error={formik.touched.sourceOfWealth && Boolean(formik.errors.sourceOfWealth)} css={{ marginTop: "10px" }}>
            <InputLabel shrink>{localeText?.DigiLockerKYCVerificationSelectWealth}</InputLabel>
            <Select
              id="sourceOfWealth"
              name="sourceOfWealth"
              value={formik.values.sourceOfWealth}
              onChange={formik.handleChange}
              size="small"
              input={
                <OutlinedInput
                  notched
                  label={localeText?.DigiLockerKYCVerificationSelectWealth}
                />
              }
            >
              <MenuItem value="">{localeText?.DigiLockerKYCVerificationSelectValue}</MenuItem>
              {fatcaOptions?.wealthMasterList?.map(opt => <MenuItem value={opt.id}>{opt.sourceOfWealthName}</MenuItem>)}
            </Select>
            <FormHelperText>{formik.touched.sourceOfWealth && formik.errors.sourceOfWealth}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <StyledTextField
            id="placeOfBirth"
            name="placeOfBirth"
            css={{ marginTop: "10px" }}
            InputLabelProps={{ shrink: true }}
            required
            value={formik.values.placeOfBirth}
            error={formik.touched.placeOfBirth && Boolean(formik.errors.placeOfBirth)}
            helperText={formik.touched.placeOfBirth && formik.errors.placeOfBirth}
            fullWidth
            label={localeText?.DigiLockerKYCVerificationPlaceBirth}
            variant="outlined"
            onChange={formik.handleChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl required fullWidth error={formik.touched.countryOfBirth && Boolean(formik.errors.countryOfBirth)} css={{ marginTop: "10px" }}>
            <InputLabel
              shrink
            >
              {localeText?.DigiLockerKYCVerificationCountryBirth}
            </InputLabel>
            <Select
              id="countryOfBirth"
              name="countryOfBirth"
              value={formik.values.countryOfBirth}
              onChange={formik.handleChange}
              size="small"
              input={
                <OutlinedInput
                  notched
                  label={localeText?.DigiLockerKYCVerificationCountryBirth}
                />
              }
            >
              <MenuItem value="">{localeText?.DigiLockerKYCVerificationSelectValue}</MenuItem>
              <MenuItem value={"India"}>{localeText?.ThirdPartyCountry}</MenuItem>
            </Select>
            <FormHelperText>{formik.touched.countryOfBirth && formik.errors.countryOfBirth}</FormHelperText>
          </FormControl>
        </Grid>
        <ConsentAgreementSection
        formik={formik}
        handleAgreementOfConsents={handleAgreementOfConsents}
        handleAgreementOfConsentsOpen={handleAgreementOfConsentsOpen}
        handleTermsAndConditions={handleTermsAndConditions}
      />
      </Grid>
    )
  }

  function handleEditClick() {
    if (isEdit) {
      formik.resetForm();
      initializeForm();
    }
    setIsEdit(!isEdit)
  }

  const form = () => {
    return (
      <form autocomplete="off" onSubmit={formik.handleSubmit} css={{ width: "100%" }}>
        <PageLayout css={{ overflowY: "scroll" }} showSidebar hideBreadcrumb calculateHeight={isSmallScreen ? true : false}>
          <ElevatedGrid>
            <Grid container item alignItems={"center"} spacing={3}>
              <Grid item xs={12}>
                <Typography display="inline" fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                  {(formik.values.accountOpeningType == "DIGI" || formik.values.accountOpeningType == "" || !(formik.values.accountOpeningType)) ? localeText?.DigiLockerKYCVerificationKycVer : localeText.CVLKRAKYCVerificationKycVer}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ElevatedGrid>
                  <Grid container>
                    <Grid item xs={10} css={{ display: "flex", flexDirection: "column" }}>
                      <Typography display="inline" fontSize={"16px"} fontWeight={"bold"} color="#525D72">
                        {formik.values.nameAsPerPan || ''}
                      </Typography>
                      <Typography display="inline" fontSize={"12px"} fontWeight={"bold"} color="#525D72">
                        {localeText?.kycDigiLockerAccount}
                      </Typography>
                    </Grid>
                    {/* <Grid item css={{ marginLeft: "auto" }}>
                      <img
                        src={isEdit ? "images/icon_close_black.svg" : "images/edit.svg"}
                        alt="edit" css={{ cursor: "pointer" }}
                        onClick={isEdit ? handleEditClick : ()=>setOpenAddressEditPopup(true)}
                      />
                    </Grid> */}
                  </Grid>
                  <Grid container>
                    {panDetails()}
                    {
                      isEdit ?
                        <>
                          {segments()}
                          {personalDetails()}
                          {addressDetails()}
                        </>
                        :
                        <>
                          {addressDetails()}
                          {segments()}
                          {personalDetails()}
                        </>
                    }
                    {fatcaDetails()}
                  </Grid>
                </ElevatedGrid>
              </Grid>
            </Grid>
            {!isSmallScreen && <Grid item xs={12} css={{ marginTop: "28px" }}>
            <Button
                type={"submit"}
                variant='contained'
                color="secondary"
                disabled={(!formik.values.isFatca || !formik.values.isAgreeToConcent || !formik.values.isAgreeMITC || !formik.values.isDDPIConsent || formik.values.politicalAffiliations !== "Not Applicable" || !formik.values.isIndian)}
              >
                {localeText?.DigiLockerKYCVerificationSave}
              </Button>
            </Grid>}
          </ElevatedGrid>
        </PageLayout>
        {isSmallScreen && <Grid item css={{ position: "fixed", bottom: 0, width: "100%", textAlign: "center", padding: "15px", boxShadow: "0px -15px 30px #00000029", backgroundColor: "#FFFFFF", zIndex: 1 }}>
        <Button
            type={"submit"}
            variant='contained'
            color="secondary"
            disabled={(!formik.values.isFatca || !formik.values.isAgreeToConcent || !formik.values.isAgreeMITC || !formik.values.isDDPIConsent || formik.values.politicalAffiliations !== "Not Applicable" || !formik.values.isIndian)}
          >
            {localeText?.DigiLockerKYCVerificationSave}
          </Button>
        </Grid>}
      </form>
    )
  }

  const proofPopup = () => {
    return (
      <ProofDialog
        setId={setId}
        onFile={onFile}
        getDocumentTypeURL={config.documentMaster + "2"}
        open={openInnerDialog}
        dialogTitle={documentTypePerName[documentTypeOption]}
        handleClose={toogleInnerDialog}
        data={documentTypeOption}
      />
    )
  }

  const imagePopup = () => {
    return (
      <DialogForUpload open={showUploadPopup} handleClose={() => { setUploadPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }} {...props} fullWidth={true} maxWidth='md'>
        <UploadDialog
          id={id}
          multiple={numberOfImages} /// gives count to images to upload
          handleClose={() => { setUploadPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
          title={documentName}
          imageArray={image ? image : null}
          count={numberOfImages}  /// gives count to images to upload
          onSave={(data) => { uploadImageProof(data); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
        />
      </DialogForUpload>
    )
  }

  const pdfPopup = () => {
    return (
      <DialogForUpload open={showPdfPopup} handleClose={() => { setPdfPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }} {...props} fullWidth={false} maxWidth='md'>
        <UploadPdf
          title={"Upload Pdf"}
          file={pdf.data}
          pdfName={pdf.name}
          handleClose={() => { setPdfPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
          onUpload={(pdfData, pdfName) => { uploadPdfProof(pdfData, pdfName); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
        />
      </DialogForUpload>
    )
  }

  const handleInput = (e) => {
    setOtp({ ...otp, [e.target.name || '']: e.target.value || '' });
  }

  console.log("Formik Values", formik.values);
  console.log("Formik Errors", formik.errors);
  return (
    <>
      {form()}
      {loading && <FullScreenLoader />}
      {documentTypeOption && proofPopup()}
      {showUploadPopup && imagePopup()}
      {showPdfPopup && pdfPopup()}
      {
        responseStatus && responseStatus.message && <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={snackBarOpen}
          autoHideDuration={5000}
          onClose={handleSnackBarClose}
        >
          <MySnackbarContentWrapper
            onClose={handleSnackBarClose}
            variant={responseStatus.type}
            message={responseStatus.message}
          />
        </Snackbar>
      }
      {
        <Popup
          open={consentOpen}
          maxWidth={"lg"}
        >
          <PopupTitle dontShowCloseIcon  onClose={handleConsentClose} customCSS={{ textAlign: "center" }}>{localeText?.DigiLockerKYCVerificationInstructions}
            <Typography variant="body1" style={{ color: "#939393" }}>
              <span style={{ fontWeight: "600", color: "#939393" }}>{localeText?.DigiLockerKYCVerificationWaiver}</span > {localeText?.DigiLockerKYCVerificationforbearance}
            </Typography></PopupTitle>
          <DialogContent>
            <Table>
              <TableHead>
                <TableCell style={{ background: "#24B7CC", color: "white" }}>Consent Tearms</TableCell>
                <TableCell style={{ background: "#24B7CC", borderLeft: "2px solid rgb(216 216 216)", color: "white" }}>Yes/ No</TableCell>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell style={{ background: "#F4F4F4" }}>{`To receive / accept each and every credit and pledge instruction in my account`}</TableCell>
                  <TableCell style={{ background: "#D8D8D8", width: "200px", textAlign: "center" }}>
                    <FormControl>
                      <FormControlLabel style={{ margin: 0 }} control={<Checkbox name={"creditPledgeInstruction"} id={"creditPledgeInstruction"} checked={checkedField["creditPledgeInstruction"]} onChange={(e) => onConsentChange("creditPledgeInstruction", e.target.checked)} />}
                      />
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ background: "#FFF" }}>{`To send Electronic Transaction, Holding Statement, ECN / Bill & all correspondence at 1st Holder Email ID stated in KYC`}</TableCell>
                  <TableCell style={{ background: "#F4F4F4", width: "200px", textAlign: "center" }}>
                    <FormControl>
                      <FormControlLabel style={{ margin: 0 }} control={<Checkbox name={"electronicContractNoteNstatement"} id={"electronicContractNoteNstatement"} checked={checkedField["electronicContractNoteNstatement"]} onChange={(e) => onConsentChange("electronicContractNoteNstatement", e.target.checked)} />}
                      />
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ background: "#F4F4F4" }}>{`To share email id with Registrar & Transfer Agent (RTA)`}</TableCell>
                  <TableCell style={{ background: "#D8D8D8", width: "200px", textAlign: "center" }}>
                    <FormControl>
                      <FormControlLabel style={{ margin: 0 }} control={<Checkbox name={"shareEmailWithRegistrarNrta"} id={"shareEmailWithRegistrarNrta"} checked={checkedField["shareEmailWithRegistrarNrta"]} onChange={(e) => onConsentChange("shareEmailWithRegistrarNrta", e.target.checked)} />}
                      />
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ background: "#FFF" }}>{`Dividend / Interest to receive in bank account stated in KYC via ECS`}</TableCell>
                  <TableCell style={{ background: "#F4F4F4", width: "200px", textAlign: "center" }}>
                    <FormControl>
                      <FormControlLabel style={{ margin: 0 }} control={<Checkbox name={"dividendInterestinBankAc"} id={"dividendInterestinBankAc"} checked={checkedField["dividendInterestinBankAc"]} onChange={(e) => onConsentChange("dividendInterestinBankAc", e.target.checked)} />}
                      />
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ background: "#F4F4F4" }}>{`To avail facility of Internet Trading & Wireless Technology`}</TableCell>
                  <TableCell style={{ background: "#D8D8D8", width: "200px", textAlign: "center" }}>
                    <FormControl>
                      <FormControlLabel style={{ margin: 0 }} control={<Checkbox name={"internetTrading"} id={"internetTrading"} checked={checkedField["internetTrading"]} onChange={(e) => onConsentChange("internetTrading", e.target.checked)} />}
                      />
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ background: "#FFF" }}>{`To receive Annual Report in Electronic mode`}</TableCell>
                  <TableCell style={{ background: "#F4F4F4", width: "200px", textAlign: "center" }}>
                    <FormControl>
                      <FormControlLabel style={{ margin: 0 }} control={<Checkbox name={"electronicAnnualReport"} id={"electronicAnnualReport"} checked={checkedField["electronicAnnualReport"]} onChange={(e) => onConsentChange("electronicAnnualReport", e.target.checked)} />}
                      />
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ background: "#F4F4F4" }}>{`To receive Rights & Obligations, RDD, Guidance Note, Policies & Procedures & all non mandatory documents in electronic and also displayed for information on website www.tradebulls.in`}</TableCell>
                  <TableCell style={{ background: "#D8D8D8", width: "200px", textAlign: "center" }}>
                    <FormControl>
                      <FormControlLabel style={{ margin: 0 }} control={<Checkbox name={"rightObligation"} id={"rightObligation"} checked={checkedField["rightObligation"]} onChange={(e) => onConsentChange("rightObligation", e.target.checked)} />}
                      />
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ background: "#FFF" }}>{`To receive Physical Delivery Instruction Slip`}</TableCell>
                  <TableCell style={{ background: "#D8D8D8", width: "200px", textAlign: "center" }}>
                    <FormControl>
                      <FormControlLabel style={{ margin: 0 }} control={<Checkbox name={"receiveDisslip"} id={"receiveDisslip"} checked={checkedField["receiveDisslip"]} onChange={(e) => onConsentChange("receiveDisslip", e.target.checked)} />}
                      />
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ background: "#F4F4F4" }}>{`DP Account Statement`}</TableCell>
                  <TableCell style={{ background: "#D8D8D8", width: "200px", textAlign: "center" }}>{`As per SEBI Regulations`}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ background: "#FFF" }}>{`CAS Flag`}</TableCell>
                  <TableCell style={{ background: "#F4F4F4", width: "200px", textAlign: "center" }}>
                    <FormControl>
                      <FormControlLabel style={{ margin: 0 }} control={<Checkbox name={"casFlag"} id={"casFlag"} checked={checkedField["casFlag"]} onChange={(e) => onConsentChange("casFlag", e.target.checked)} />}
                      />
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ background: "#F4F4F4" }}>{`CAS Mode`}</TableCell>
                  <TableCell style={{ background: "#D8D8D8", width: "200px", textAlign: "center" }}>{`eCAS`}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ background: "#FFF" }}>{`Preferred Depository`}</TableCell>
                  <TableCell style={{ background: "#F4F4F4", width: "200px", textAlign: "center" }}>{`CDSL`}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ background: "#F4F4F4" }}>{`Details of any action / proceedings initiated / pending / taken by SEBI / Stock exchange / any other authority against the applicant / constituent or its Partners / promoters / whole time directors /authorized persons in charge of dealing in securities during the last 3 years`}</TableCell>
                  <TableCell style={{ background: "#D8D8D8", width: "200px", textAlign: "center" }}>
                    <FormControl>
                      <FormControlLabel style={{ margin: 0 }} control={<Checkbox name={"pastAction"} id={"pastAction"} checked={checkedField["pastAction"]} onChange={(e) => onConsentChange("pastAction", e.target.checked)} />}
                      />
                    </FormControl>
                  </TableCell>
                </TableRow>
                {(checkedField["pastAction"]) &&
                  <TableRow>
                    <FormControl fullWidth >
                      <TextField id="pastActionReason" label="Details of action" variant="outlined" InputLabelProps={{ shrink: true }} inputProps={{ maxLength: 100, }} value={checkedField["pastActionReason"]} onChange={(e) => {
                        if (e.currentTarget.value.match(/^[0-9a-z ]+$/)) {
                          onConsentChange("pastActionReason", e.currentTarget.value)
                        }
                      }} />
                    </FormControl>
                  </TableRow>
                }
                <TableRow>
                  <TableCell style={{ background: "#FFF" }}>{`Client Authorisation to maintain Running Account`}</TableCell>
                  <TableCell style={{ background: "#F4F4F4", width: "200px", textAlign: "center" }}>

                    <Select
                      id="authRunningAccount"
                      name="authRunningAccount"
                      value={checkedField["authRunningAccount"]}
                      onChange={(e) => { onConsentChange("authRunningAccount", e?.target?.value) }}
                      size="small"
                      input={
                        <OutlinedInput
                          notched
                          label={"Running Authorization"}
                        />
                      }
                    >
                      <MenuItem value=""></MenuItem>
                      <MenuItem value={"Quaterly"}>{"Quaterly"}</MenuItem>
                      <MenuItem value={"Monthly"}>{"Monthly"}</MenuItem>
                    </Select>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions style={{ display: "-webkit-box" }}>
            <Grid container>
              <Grid item xs={11}>
                <Typography variant={"body1"} style={{ marginTop: "5px", color: "#858585" }} >
                  <span style={{ fontWeight: "600" }}>Note:To register for Easi please visit website <Link target='_blank' href="https://www.cdslindia.com">www.cdslindia.com</Link>, where BO can view ISIN balances, transactions & portfolio online.</span>
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Button variant="contained" color="primary" disabled={isConsentSatisfied} onClick={handleConsentClose}>
                  {localeText?.AddressOk}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Popup>

      }
      {
        <Popup
          open={mitcConsentOpen}
          maxWidth={"lg"}
        >
          <PopupTitle dontShowCloseIcon onClose={handleMitcConsentClose} customCSS={{ textAlign: "center" }}>{localeText?.DigiLockerKYCVerificationMITC}</PopupTitle>
          <DialogContent>
            <Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MITCContentData?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
            </Grid>
          </DialogContent>
          <DialogActions style={{ display: "-webkit-box" }}>
                <Button variant="contained" color="primary" onClick={handleMitcConsentClose} style={{ float: 'right'}}>
                    {localeText?.AddressOk}
                </Button>
          </DialogActions>
        </Popup>
      }
      {
        <Popup
          open={ddpiConsentOpen}
          maxWidth={"lg"}
        >
          <PopupTitle dontShowCloseIcon  onClose={handleDdpiConsentClose} customCSS={{ textAlign: "center" }}>{localeText?.DigiLockerKYCVerificationDDPI}</PopupTitle>
          <DialogContent>
            <Grid padding={'0px 30px 1px 30px'}>
            <Grid my={1} sx={{display:'flex', justifyContent:'center', alignItems:'center', paddingBottom:'10px'}}>
                <Typography variant='p'>{localeText.consentDDPITitle}</Typography>
                </Grid>
                <Grid my={1} sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <Typography variant='p'>{localeText.consentDDPIDesc}</Typography>
                </Grid>
              <Grid padding={'0px 15px 0px 15px'}>
                <Table>
                  <TableHead>
                    <TableCell style={{ background: "#24B7CC", color: "white" }}>Consent Tearms</TableCell>
                    <TableCell style={{ background: "#24B7CC", borderLeft: "2px solid rgb(216 216 216)", color: "white" }}>Yes/ No</TableCell>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell style={{ background: "#F4F4F4" }}>{localeText?.consentDDPI1}</TableCell>
                      <TableCell style={{ background: "#D8D8D8", width: "200px", textAlign: "center" }}>
                        <FormControl>
                          <FormControlLabel style={{ margin: 0 }} control={<Checkbox name={"transferOfSecurities"} id={"transferOfSecurities"} checked={isDdpiCheckedField["transferOfSecurities"]} onChange={(e) => onDdpiConsentChange("transferOfSecurities", e.target.checked)} />}
                          />
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ background: "#FFF" }}>{localeText?.consentDDPI2}</TableCell>
                      <TableCell style={{ background: "#F4F4F4", width: "200px", textAlign: "center" }}>
                        <FormControl>
                          <FormControlLabel style={{ margin: 0 }} control={<Checkbox name={"pledgingRepledgingOfSecurities"} id={"pledgingRepledgingOfSecurities"} checked={isDdpiCheckedField["pledgingRepledgingOfSecurities"]} onChange={(e) => onDdpiConsentChange("pledgingRepledgingOfSecurities", e.target.checked)} />}
                          />
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ background: "#F4F4F4" }}>{localeText?.consentDDPI3}</TableCell>
                      <TableCell style={{ background: "#D8D8D8", width: "200px", textAlign: "center" }}>
                        <FormControl>
                          <FormControlLabel style={{ margin: 0 }} control={<Checkbox name={"mutualFundTransactions"} id={"mutualFundTransactions"} checked={isDdpiCheckedField["mutualFundTransactions"]} onChange={(e) => onDdpiConsentChange("mutualFundTransactions", e.target.checked)} />}
                          />
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ background: "#FFF" }}>{localeText?.consentDDPI4}</TableCell>
                      <TableCell style={{ background: "#F4F4F4", width: "200px", textAlign: "center" }}>
                        <FormControl>
                          <FormControlLabel style={{ margin: 0 }} control={<Checkbox name={"tenderingSharesInOpenOffers"} id={"tenderingSharesInOpenOffers"} checked={isDdpiCheckedField["tenderingSharesInOpenOffers"]} onChange={(e) => onDdpiConsentChange("tenderingSharesInOpenOffers", e.target.checked)} />}
                          />
                        </FormControl>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ display: "-webkit-box" }}>
                <Button variant="contained" color="primary" disabled={isDDPIConsentSatisfied} onClick={handleDdpiConsentClose} style={{ float: 'right'}}>
                    {localeText?.AddressOk}
                </Button>
          </DialogActions>
        </Popup>
      }
      {
        <Popup
          open={mtfConsentOpen}
          maxWidth={"lg"}
        >
          <PopupTitle dontShowCloseIcon onClose={handleMtfConsentClose} customCSS={{ textAlign: "center" }}>{localeText?.DigiLockerKYCVerificationMTF}</PopupTitle>
          <DialogContent>
            <Grid>
                <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForMarginTrading}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentDataForClientRights?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForClientRights}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentDataForClient?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForClientObligationsTitle}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentDataForClientObligations?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForStockBrokerRightsTitle}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentForStockBrokerRights?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForStockBrokerObligationsTitle}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentForStockBrokerObligations?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForTerminationOfRelationTitle}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentForTerminationOfRelation?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForMarginTradingFacility}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
              {MTFConsentMarginTradingQuestions.map((item, i) => (
                <ListItem key={i} sx={{ display: "list-item" }}>
                <ListItemText>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{item.instruction}</Typography>
                </ListItemText>
                {Array.isArray(MTFConsentForTermsofTBAnswer[i].instruction) ? (
                    MTFConsentForTermsofTBAnswer[i].instruction.map((answerItem, j) => (
                    <ul style={{ color: '#24B7CC !important', paddingRight: '15px' }}>
                            <li key={j}> {answerItem}</li>
                    </ul>
                    ))
                ) : (
                    <ListItemText primary={MTFConsentForTermsofTBAnswer[i].instruction} />
                )}
                </ListItem>))}
              </List>
            </Grid>
          </DialogContent>
          <DialogActions style={{ display: "-webkit-box" }}>
            <Button variant="contained" color="primary" onClick={handleMtfConsentClose} style={{ float: 'right'}}>
                    {localeText?.AddressOk}
            </Button>                   
          </DialogActions>
        </Popup>
      }

      {
        <Popup
          open={openProfilePhonePopup}
          maxWidth={"sm"}
        >
          <PopupTitle onClose={handleCloseContactVerification} />
          <DialogContent css={{ textAlign: "center", margin: "0px 40px" }}>
            <Typography css={{ marginBottom: "10px", fontSize: "12px", color: "#24B7CC" }}>
              {localeText?.DigiLockerKYCVerificationSent}
            </Typography>
            <TextField
              hiddenLabel
              id="filled-hidden-label-small"
              InputProps={{ disableUnderline: true }}
              variant="filled"
              size="small"
              sx={{ width: "70%" }}
              name="contactotp"
              inputProps={{ maxLength: 6 }}
              required
              value={otp.contactotp}
              onChange={handleInput}
            />
            {!loader && <div css={{ textAlign: "center", margin: "5px 0px 15px 0px" }}>
              <Typography variant='caption' css={{ textDecoration: "underline", color: "#24B7CC", cursor: "pointer" }} disabled={loader} onClick={getContactVerification}>
                {localeText?.profileOtp}
              </Typography>
            </div>}
            <div css={{ textAlign: "center", margin: "5px 0px 15px 0px", color: "#24B7CC" }}>
              {loader && <TextLoader name={localeText?.DigiLockerKYCVerificationSending} />}
            </div>

            <Stack spacing={2} direction="row" css={{ marginLeft: "12px" }}>
              <Button variant='outlined' color="secondary" css={{ width: "115px" }} onClick={handleCloseContactVerification}>
                {localeText?.DigiLockerKYCVerificationBack}
              </Button>

              <Button variant='contained' color="secondary" css={{ width: "115px" }} onClick={contactVerification}>
                {localeText?.DigiLockerKYCVerificationSubmit}
              </Button>
            </Stack>


          </DialogContent>
        </Popup>
      }
      {
            <Popup
            open={openInfoPopup}
            maxWidth={isSmallScreen ? 'xs' :'md'}
            margin='0px !important'
            width='100% !important'
            fullWidth  
            sx={{
              "& .MuiDialog-paper": {
                  margin:'0px !important',
                  width: 'calc(100% - 10px)'
              }
          }}          
        >
            <PopupTitle onClose={()=>handleToggleInfoPopup()}/>
            <DialogContent css={{ textAlign: "center", padding:isSmallScreen ? "20px 0px" : "20px", width:'100%'}}>
                <Grid container direction={"column"} alignItems={"center"} justifyContent="center"  >
                    <Grid item sx={{width:'100%'}}>
                <div className="pan-guide-wrap" /* style={{minWidth:!isSmallScreen && "880px"}} */ >
                  <h2 className="info">PAN Information filling guide</h2>
                  <div className="d-flex">
                    <div className="col">
                      <h3 className="txt-brown">Sample 1</h3>
                      <div className="pan-guide-animation">
                        <div className="pan-1">
                          <img src="images/pan-1.png" alt="Pancard" className="" width="360" height="215"/>
                            <div className="hover-box-1">
                              <span className="top"></span>
                              <span className="left"></span>
                              <span className="bottom"></span>
                              <span className="txt-box">AXXXKYA</span>
                              {/* <!-- <span className="hold-animation"></span> --> */}
                            </div>
                            <div className="hover-box-2">
                              <span className="right"></span>
                              <span className="top"></span>
                              <span className="left"></span>
                              <span className="bottom"></span>
                              <span className="txt-box">AVXXASH</span>
                              {/* <!-- <span className="hold-animation"></span> --> */}
                            </div>
                            <div className="hover-box-3">
                              <span className="right"></span>
                              <span className="top"></span>
                              <span className="left"></span>
                              <span className="bottom"></span>
                              <span className="txt-box">AXXR</span>
                              {/* <!-- <span className="hold-animation"></span> --> */}
                            </div>
                        </div>
                        <div className="input-wrap">
                          <img src="images/input-fields.svg" alt="Input Fields" className=""/>
                        </div>
                        <div className="txt-note">
                          <p><span className="txt-red">Note:</span> If your First row contains your First name, Middle & Last name, Then fill the Middle & Last name input of the form accordingly.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <h3 className="txt-brown">Sample 2</h3>
                      <div className="pan-guide-animation" >
                        <div className="pan-2">
                          <img src="images/pan-2.png" alt="Pancard" className="" width="360" height="215"/>
                            <div className="hover-box-1">
                              <span className="top"></span>
                              <span className="left"></span>
                              <span className="bottom"></span>
                              <span className="txt-box">PAXXAXX</span>
                              <span className="icon-incorrect">Not required</span>
                              <span className="icon-incorrect icon-2">Not required</span>
                            </div>
                        </div>
                        <div className="input-wrap">
                          <img src="images/input-fields.svg" alt="Input Fields" className=""/>
                        </div>
                        <div className="txt-note">
                          <p><span className="txt-red">Note:</span> If your first row contains only your first name then, Kindly leave the middle name and last name inputs of form blank.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                        {/* <img src={isSmallScreen ? "images/popupImg_mob.png" : "images/popupImg_web.png"} alt="error" style={{width:isSmallScreen ? '300px':'900px', height:isSmallScreen ? '300px' : '450px'}}/> */}
                    </Grid>
                    <Grid item xs={12} css={{ padding: "20px 0" }}>
                        <Button variant="contained" color="secondary" css={{ textTransform: "none"}} onClick={() => {
                            handleToggleInfoPopup();
                        }}>
                            {localeText?.popupImgCloseBtn}
                        </Button>

                    </Grid>
                </Grid>
            </DialogContent>
        </Popup>
      }
      <Popup
                open={openAddressEditPopup}
                maxWidth={"sm"}
            >
                <PopupTitle onClose={toggleAddressEdittingPopup}>{localeText?.AddressConfirmation}</PopupTitle>
                <DialogContent >
                        <Grid sx={{ "& .MuiPaper-root": { color: '#24B7CC !important' } }}>
                        <ul style={{ color: '#24B7CC !important', paddingRight: '15px' }}>
                            <li>
                                <p>{(formik.values.accountOpeningType == "DIGI" || formik.values.accountOpeningType == "" || !(formik.values.accountOpeningType)) ? localeText?.ThirdPartyDIGIDataRecieved : localeText?.ThirdPartyCDSLDataRecieved }</p>
                            </li>
                            <li>
                            <p>{(formik.values.accountOpeningType == "DIGI" || formik.values.accountOpeningType == "" || !(formik.values.accountOpeningType)) ? localeText?.ThirdPartyDIGIAdressDataWillChange : localeText?.ThirdPartyCDSLAdressDataWillChange }</p>
                            </li>
                            <li>
                                <p>{localeText?.manualKRAAdressDataShouldUpload}</p>
                            </li>
                        </ul>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    
                    <Grid /* direction={"row-reverse"} */ alignItems={"center"} justifyContent={"flex-end"} container spacing={2} css={{ padding: "10px" }}>
                        <Grid item>
                            <Button variant="contained" color="primary" onClick={toggleAddressEdittingPopup}>
                               {localeText?.AddressCancel}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="outlined" color="primary"  onClick={() => { toggleAddressEdittingPopup(); handleEditClick()}}>
                            {localeText?.AddressOk}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Popup>
    </>
  );
}

export default ThirdPartyKYCVerification;
